const spainShape = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "id": "ES",
      "properties": {
        "name": "Spain",
        "density": 0
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -5.3407283185567245,
                35.84735746923506
              ],
              [
                -5.362897908352232,
                35.86380683625679
              ],
              [
                -5.378400837636423,
                35.88168689392731
              ],
              [
                -5.389717977589425,
                35.902047450994516
              ],
              [
                -5.398858679593803,
                35.924503879118255
              ],
              [
                -5.38516191274441,
                35.926174209735244
              ],
              [
                -5.366200325143347,
                35.924750073346324
              ],
              [
                -5.344105598394359,
                35.914740319529685
              ],
              [
                -5.327381964904654,
                35.904242250751075
              ],
              [
                -5.3093155581927025,
                35.90082424986853
              ],
              [
                -5.283070441722461,
                35.91168853152361
              ],
              [
                -5.291859503882763,
                35.890529684735284
              ],
              [
                -5.33556067660789,
                35.86237216412107
              ],
              [
                -5.3407283185567245,
                35.84735746923506
              ]
            ]
          ],
          [
            [
              [
                -2.9478246740745244,
                35.329779370151485
              ],
              [
                -2.922027147977347,
                35.28799062511805
              ],
              [
                -2.9131973950485635,
                35.27724844406667
              ],
              [
                -2.912912563937629,
                35.27692291378694
              ],
              [
                -2.9430456140974437,
                35.26787425607962
              ],
              [
                -2.9637678629683126,
                35.28621937840415
              ],
              [
                -2.9669201260985902,
                35.31386628009475
              ],
              [
                -2.9478246740745244,
                35.329779370151485
              ]
            ]
          ],
          [
            [
              [
                -1.7940747454915296,
                43.386015390570016
              ],
              [
                -1.7964489325223956,
                43.3743818774005
              ],
              [
                -1.79717240449177,
                43.35332392047372
              ],
              [
                -1.7969140216380382,
                43.341128200048956
              ],
              [
                -1.7682336009281359,
                43.33092203478075
              ],
              [
                -1.755779581028955,
                43.318545537978224
              ],
              [
                -1.752420612905716,
                43.29908944866429
              ],
              [
                -1.7497299857586743,
                43.29479266704348
              ],
              [
                -1.747356322175916,
                43.29100201405529
              ],
              [
                -1.7365559478705448,
                43.292319730996276
              ],
              [
                -1.7248253990719842,
                43.29653158199436
              ],
              [
                -1.7033280036493217,
                43.29862443624442
              ],
              [
                -1.683019165307799,
                43.30492892577507
              ],
              [
                -1.6738724364413322,
                43.30415379380786
              ],
              [
                -1.6549071864023739,
                43.29753920625502
              ],
              [
                -1.645036986478474,
                43.29237146592045
              ],
              [
                -1.6451920178974209,
                43.28764322280446
              ],
              [
                -1.6479825439349307,
                43.281545302145844
              ],
              [
                -1.646328899078617,
                43.27278626692141
              ],
              [
                -1.639042521769255,
                43.25568133664985
              ],
              [
                -1.634081582751198,
                43.25110775706112
              ],
              [
                -1.621885944823054,
                43.246999486755264
              ],
              [
                -1.611085570761379,
                43.24581092224538
              ],
              [
                -1.598476520840075,
                43.246999486755264
              ],
              [
                -1.5875727956635988,
                43.25159888972819
              ],
              [
                -1.5818883883632002,
                43.260358120883865
              ],
              [
                -1.5739818932365017,
                43.277437058130296
              ],
              [
                -1.5590474045986624,
                43.28407752074831
              ],
              [
                -1.5392036558852173,
                43.28356078996656
              ],
              [
                -1.508094441102653,
                43.2767651355725
              ],
              [
                -1.4663915608262184,
                43.26077136240323
              ],
              [
                -1.4552811279690219,
                43.262218319315586
              ],
              [
                -1.4442223723662067,
                43.26511224710338
              ],
              [
                -1.4322334384526065,
                43.26500878353872
              ],
              [
                -1.4035013434947419,
                43.24333064834207
              ],
              [
                -1.3996772872566037,
                43.20674370493959
              ],
              [
                -1.410529336950383,
                43.166901014253945
              ],
              [
                -1.4257738861921796,
                43.13527531294875
              ],
              [
                -1.4384346107272206,
                43.12279527590499
              ],
              [
                -1.479620727596033,
                43.09026494730184
              ],
              [
                -1.4878372802109867,
                43.08181592280101
              ],
              [
                -1.475279907757241,
                43.06013772378208
              ],
              [
                -1.4571414801784253,
                43.04507409653543
              ],
              [
                -1.4350239654220731,
                43.03572044951564
              ],
              [
                -1.410529337798032,
                43.03091458694737
              ],
              [
                -1.3831408275584234,
                43.02920923412625
              ],
              [
                -1.3661392837569821,
                43.033317664003484
              ],
              [
                -1.3576126706754763,
                43.04683091118382
              ],
              [
                -1.3551838782827745,
                43.073030940492494
              ],
              [
                -1.3482592375012374,
                43.09308142498232
              ],
              [
                -1.3310509857922805,
                43.107344159984045
              ],
              [
                -1.3086234136088064,
                43.113571147261325
              ],
              [
                -1.2860408113523605,
                43.10917848104628
              ],
              [
                -1.3069697665852913,
                43.09597518456452
              ],
              [
                -1.315082967927573,
                43.08287538831058
              ],
              [
                -1.3105871171654868,
                43.06949095766225
              ],
              [
                -1.293688924771327,
                43.05520263930873
              ],
              [
                -1.2748787026952624,
                43.04683091118382
              ],
              [
                -1.2168977468279023,
                43.039260475088696
              ],
              [
                -1.182532918498046,
                43.02528180668973
              ],
              [
                -1.149925089467984,
                43.00572242331589
              ],
              [
                -1.1124080008173458,
                43.00825462471468
              ],
              [
                -1.1037263595319586,
                43.005748274448635
              ],
              [
                -1.0871899005309253,
                42.99799664940674
              ],
              [
                -1.0796968171079526,
                42.99339737722258
              ],
              [
                -1.0450736083017327,
                42.99021930490931
              ],
              [
                -1.02848547449134,
                42.98670550775936
              ],
              [
                -1.016289834805674,
                42.97624091348066
              ],
              [
                -0.9814599204938238,
                42.95704306153608
              ],
              [
                -0.9432193612480415,
                42.947896469167155
              ],
              [
                -0.8635343024319846,
                42.94306476481254
              ],
              [
                -0.7864330648143905,
                42.95327073160496
              ],
              [
                -0.7596646735788289,
                42.94650129375314
              ],
              [
                -0.7450319632844938,
                42.91872729409628
              ],
              [
                -0.7409061283607983,
                42.91089594644679
              ],
              [
                -0.7414228918757655,
                42.903893912582156
              ],
              [
                -0.7447818596930257,
                42.89929466658642
              ],
              [
                -0.7458670661430244,
                42.89392042372856
              ],
              [
                -0.7402860106019479,
                42.88479940448899
              ],
              [
                -0.7301057542262416,
                42.87751317751697
              ],
              [
                -0.7202872314065415,
                42.876608640135245
              ],
              [
                -0.7105203863564346,
                42.87766824124524
              ],
              [
                -0.7003918054735123,
                42.87642803691633
              ],
              [
                -0.6660786539288251,
                42.86074410122417
              ],
              [
                -0.6483019616261568,
                42.84978861553494
              ],
              [
                -0.6094929614261104,
                42.81144492721056
              ],
              [
                -0.6080460213678558,
                42.80718160463353
              ],
              [
                -0.609958049424261,
                42.802840801606706
              ],
              [
                -0.6101647536824284,
                42.79909404527402
              ],
              [
                -0.6035501713351235,
                42.79684630990454
              ],
              [
                -0.5873237713260898,
                42.79684630990454
              ],
              [
                -0.5829312751673598,
                42.795838571634334
              ],
              [
                -0.5771435143687285,
                42.78979249167192
              ],
              [
                -0.5785387778047616,
                42.783306927501506
              ],
              [
                -0.5786938065467407,
                42.77733822087908
              ],
              [
                -0.5690303135263786,
                42.77263565720159
              ],
              [
                -0.5611754955281782,
                42.77353999269835
              ],
              [
                -0.5444323327442655,
                42.78201499319859
              ],
              [
                -0.5356473388773058,
                42.78421128363838
              ],
              [
                -0.5338903395780304,
                42.808008182741005
              ],
              [
                -0.5084138593698798,
                42.80749168525245
              ],
              [
                -0.45446366321581066,
                42.78891396376377
              ],
              [
                -0.42392289334427286,
                42.79067102123229
              ],
              [
                -0.39973832207419285,
                42.80131625574522
              ],
              [
                -0.3516792401207875,
                42.82924739554113
              ],
              [
                -0.34299759989273515,
                42.822736049946826
              ],
              [
                -0.33516861976791085,
                42.824958069080914
              ],
              [
                -0.3282439777348965,
                42.83258032281119
              ],
              [
                -0.32279211398135893,
                42.84250232985942
              ],
              [
                -0.3074183761191712,
                42.8318312253395
              ],
              [
                -0.3051349378747605,
                42.83081003474559
              ],
              [
                -0.24703446392367162,
                42.80483016664799
              ],
              [
                -0.23514888600951056,
                42.786226712182334
              ],
              [
                -0.20835465494408717,
                42.78387537972612
              ],
              [
                -0.17939001511333125,
                42.789740813513944
              ],
              [
                -0.1614066160246353,
                42.7953476230086
              ],
              [
                -0.16362870287662462,
                42.7779841811221
              ],
              [
                -0.1577892660405529,
                42.76069859244395
              ],
              [
                -0.14572281907950413,
                42.74589334641946
              ],
              [
                -0.12923803692314567,
                42.73589375505434
              ],
              [
                -0.12311438005219552,
                42.73036455705102
              ],
              [
                -0.12182246891405288,
                42.723310524432954
              ],
              [
                -0.11903194200840482,
                42.716851107658876
              ],
              [
                -0.1084899500906667,
                42.71336308383814
              ],
              [
                -0.09575170894391925,
                42.71067565755518
              ],
              [
                -0.08885290596279917,
                42.70612816121042
              ],
              [
                -0.08420202703607785,
                42.701089858930715
              ],
              [
                -0.07841426594366054,
                42.6966713210503
              ],
              [
                -0.038933472020391026,
                42.68514769705375
              ],
              [
                -0.004310262998756789,
                42.68752467215878
              ],
              [
                0.07284265095674197,
                42.70847940767276
              ],
              [
                0.13418257593169725,
                42.71522319788594
              ],
              [
                0.15294112103544166,
                42.72460260081507
              ],
              [
                0.16916752085494177,
                42.72646275936556
              ],
              [
                0.2223942461154141,
                42.71620523165401
              ],
              [
                0.23836226391648638,
                42.710365641035175
              ],
              [
                0.2598079830271308,
                42.68238293237693
              ],
              [
                0.2753884277733821,
                42.668688514288505
              ],
              [
                0.29024540217319167,
                42.670290734583986
              ],
              [
                0.31830570402890257,
                42.6995395060339
              ],
              [
                0.33603072087052094,
                42.71269107385748
              ],
              [
                0.35416914786893144,
                42.71749698455145
              ],
              [
                0.38181603983972373,
                42.70010785672825
              ],
              [
                0.3840122883207457,
                42.696852462659976
              ],
              [
                0.383676390867337,
                42.692692301797635
              ],
              [
                0.38439986213619015,
                42.68858414862481
              ],
              [
                0.38928328520488903,
                42.68514769705375
              ],
              [
                0.409282064100867,
                42.68225376656629
              ],
              [
                0.4287899167382175,
                42.68302876196122
              ],
              [
                0.4669271240808921,
                42.690444468633444
              ],
              [
                0.4835152591749102,
                42.68530269698274
              ],
              [
                0.6081588125409215,
                42.687989674445106
              ],
              [
                0.6436088456994743,
                42.68447572736306
              ],
              [
                0.6567346595042403,
                42.687989674445106
              ],
              [
                0.663425813479829,
                42.69621421233178
              ],
              [
                0.6654163004442039,
                42.698660843290014
              ],
              [
                0.6664498288819559,
                42.714758168683844
              ],
              [
                0.6596285404438976,
                42.729899512857635
              ],
              [
                0.6476396084078819,
                42.74103577618242
              ],
              [
                0.6334802645033544,
                42.74478206754237
              ],
              [
                0.6395780838073709,
                42.75483321882199
              ],
              [
                0.6432987873443796,
                42.75907083447098
              ],
              [
                0.6507401939054884,
                42.763385697352135
              ],
              [
                0.6396814364601865,
                42.774676874089174
              ],
              [
                0.6537374274222357,
                42.80268576281705
              ],
              [
                0.6515670163107132,
                42.82405393797508
              ],
              [
                0.656321248065082,
                42.83841991943322
              ],
              [
                0.6793689372910614,
                42.8451120754047
              ],
              [
                0.7067574459885182,
                42.84658477611624
              ],
              [
                0.724327433425833,
                42.845292970472045
              ],
              [
                0.7588472895583314,
                42.83526753749955
              ],
              [
                0.7763139246418878,
                42.83245141958894
              ],
              [
                0.7957442630843672,
                42.83384655565347
              ],
              [
                0.812900838199113,
                42.831624494106585
              ],
              [
                0.8561023356420399,
                42.81276247930769
              ],
              [
                0.8857646075328341,
                42.80423584903341
              ],
              [
                0.8944462475976596,
                42.799326601688136
              ],
              [
                0.9103625892369699,
                42.7876736918825
              ],
              [
                0.921111286803183,
                42.78436631629471
              ],
              [
                0.9306197513036025,
                42.78803543750776
              ],
              [
                0.9400248617538906,
                42.79366806582421
              ],
              [
                0.9502567953412592,
                42.79612280528519
              ],
              [
                0.9587317297630694,
                42.79371974441672
              ],
              [
                0.9752681887235145,
                42.78374618597798
              ],
              [
                0.9829162994010542,
                42.780361322501335
              ],
              [
                1.0681824131222968,
                42.776123818037966
              ],
              [
                1.0890596911379467,
                42.77131791432187
              ],
              [
                1.1067330324818763,
                42.75961341983327
              ],
              [
                1.1165515548629656,
                42.7452474304496
              ],
              [
                1.1240963138478408,
                42.7297444982289
              ],
              [
                1.1343282477735435,
                42.71597271650959
              ],
              [
                1.1514848239400297,
                42.70672265830072
              ],
              [
                1.1625435789306544,
                42.705688975447934
              ],
              [
                1.1959265547542282,
                42.71364726745235
              ],
              [
                1.3191231701034505,
                42.71336308383814
              ],
              [
                1.342584268004279,
                42.70866024989243
              ],
              [
                1.3382434485590138,
                42.69444930271525
              ],
              [
                1.3433077392326933,
                42.690444468633444
              ],
              [
                1.352712850762416,
                42.690056964676586
              ],
              [
                1.3610844327769256,
                42.68672383596394
              ],
              [
                1.378757770178363,
                42.66323669049871
              ],
              [
                1.3979814045403995,
                42.64362565846028
              ],
              [
                1.4148279201030058,
                42.609338164568435
              ],
              [
                1.4292973229112431,
                42.59538575408938
              ],
              [
                1.4248531500396207,
                42.58936534092119
              ],
              [
                1.419272095978989,
                42.57926271642256
              ],
              [
                1.4180318588819005,
                42.5698315050004
              ],
              [
                1.4264034409424138,
                42.56564572232661
              ],
              [
                1.4263000905289747,
                42.56179602585248
              ],
              [
                1.4097636313634048,
                42.540608667799575
              ],
              [
                1.4064563392298404,
                42.529239837039775
              ],
              [
                1.428987263569869,
                42.53146184047738
              ],
              [
                1.4465572506359492,
                42.519886329234424
              ],
              [
                1.4499678955326318,
                42.504073449353626
              ],
              [
                1.4302274976477591,
                42.49355718715554
              ],
              [
                1.4245430899451665,
                42.49247201914705
              ],
              [
                1.4075932204655937,
                42.486761712398895
              ],
              [
                1.4364286702082876,
                42.45348218383552
              ],
              [
                1.4364286700719628,
                42.440950631925375
              ],
              [
                1.4479008386086987,
                42.43464617296104
              ],
              [
                1.5084656168207133,
                42.42867744878597
              ],
              [
                1.5166304928724625,
                42.42950427798713
              ],
              [
                1.5282060145807985,
                42.43423275376425
              ],
              [
                1.5345105388025841,
                42.439917071049344
              ],
              [
                1.5388513596048699,
                42.44565324805875
              ],
              [
                1.5444324142108834,
                42.45035575832744
              ],
              [
                1.607477661158019,
                42.45642773150295
              ],
              [
                1.6395170485366921,
                42.46642705364612
              ],
              [
                1.6503691004433445,
                42.493402249803324
              ],
              [
                1.6539864502439214,
                42.496528652237735
              ],
              [
                1.6569836828470124,
                42.497639652560636
              ],
              [
                1.6597742101106023,
                42.49681285784454
              ],
              [
                1.662358032153753,
                42.49371227645735
              ],
              [
                1.6742436105421905,
                42.490508272319545
              ],
              [
                1.6863358963804849,
                42.49061171515611
              ],
              [
                1.6974980062668885,
                42.494461596975185
              ],
              [
                1.7070064704259535,
                42.50278151839286
              ],
              [
                1.7100037026646728,
                42.501334499099244
              ],
              [
                1.711967406338995,
                42.4992932462791
              ],
              [
                1.7126908772577707,
                42.49678703477335
              ],
              [
                1.7121741131583765,
                42.49371227645735
              ],
              [
                1.7305709235931725,
                42.4880537520099
              ],
              [
                1.7926859947953155,
                42.481723307664765
              ],
              [
                1.813666625262666,
                42.47523786359404
              ],
              [
                1.8697872324487452,
                42.446790102771224
              ],
              [
                1.8932483317317397,
                42.442733434732354
              ],
              [
                1.911955200664008,
                42.4419583749044
              ],
              [
                1.9274581288937682,
                42.43689401316687
              ],
              [
                1.9411007088005374,
                42.42009925557292
              ],
              [
                1.9542265216235692,
                42.3826854105858
              ],
              [
                1.963734985279253,
                42.36723421740517
              ],
              [
                1.9833720295154569,
                42.35454758431354
              ],
              [
                1.99567101998563,
                42.348682351704475
              ],
              [
                2.0092102457497325,
                42.347080449729035
              ],
              [
                2.035255167390227,
                42.34925074041661
              ],
              [
                2.0516882738556923,
                42.352351454567945
              ],
              [
                2.063263794500563,
                42.35790664036684
              ],
              [
                2.080110310248469,
                42.37126488943155
              ],
              [
                2.1039848233176954,
                42.384830043960015
              ],
              [
                2.1087390541023825,
                42.3906436246601
              ],
              [
                2.116283813286334,
                42.40539726114424
              ],
              [
                2.1210380443928423,
                42.41061650590004
              ],
              [
                2.1369543853035338,
                42.416223391836866
              ],
              [
                2.184186644409166,
                42.411805066715
              ],
              [
                2.2459916593135696,
                42.42611951189504
              ],
              [
                2.2774109302041534,
                42.428625809977774
              ],
              [
                2.305316202810344,
                42.41697274331051
              ],
              [
                2.3173051345006894,
                42.40960882853758
              ],
              [
                2.3754927981413037,
                42.38932587761632
              ],
              [
                2.4066020105045562,
                42.384261613439044
              ],
              [
                2.4225183516454316,
                42.38369318358704
              ],
              [
                2.429856404865203,
                42.36754431463293
              ],
              [
                2.4455660394982637,
                42.35196376930428
              ],
              [
                2.4648930247359195,
                42.340620809828074
              ],
              [
                2.483393187573726,
                42.33697761028206
              ],
              [
                2.5036503496150715,
                42.32845100248488
              ],
              [
                2.514812459120932,
                42.32566051160158
              ],
              [
                2.525251097176459,
                42.32589298862634
              ],
              [
                2.5319690339884744,
                42.33077639850379
              ],
              [
                2.540340617095478,
                42.34697703771604
              ],
              [
                2.548092081205726,
                42.35224804142967
              ],
              [
                2.5674190666420516,
                42.352635575065975
              ],
              [
                2.6134110916893865,
                42.34095670472914
              ],
              [
                2.6354252537496814,
                42.33788202988915
              ],
              [
                2.662193645093856,
                42.339018934498206
              ],
              [
                2.661780230887572,
                42.34335960524
              ],
              [
                2.6493778878983023,
                42.35372073163956
              ],
              [
                2.6402828365574162,
                42.372841055036744
              ],
              [
                2.6482410078246503,
                42.38147110462067
              ],
              [
                2.690408976451992,
                42.40617241398268
              ],
              [
                2.7080823165496164,
                42.41289035621437
              ],
              [
                2.728546181952951,
                42.41402713352106
              ],
              [
                2.7677169190120665,
                42.40955719177394
              ],
              [
                2.7885941971506303,
                42.41201176663972
              ],
              [
                2.8046138923521746,
                42.419556602396995
              ],
              [
                2.834792928933867,
                42.441312416727676
              ],
              [
                2.8508126223297707,
                42.44836621160971
              ],
              [
                2.866935670033703,
                42.44963232726365
              ],
              [
                2.884092245981771,
                42.44919307466979
              ],
              [
                2.9008354092550275,
                42.451260086660824
              ],
              [
                2.933701617810263,
                42.47022524976119
              ],
              [
                2.966051066177642,
                42.461001089662425
              ],
              [
                2.983104289897487,
                42.46932103758457
              ],
              [
                2.9937496329672766,
                42.46761560054477
              ],
              [
                3.0229984940533994,
                42.46704722413969
              ],
              [
                3.0296130769758944,
                42.46565195557458
              ],
              [
                3.036020956308028,
                42.45461905707673
              ],
              [
                3.0438757735924744,
                42.44526563969212
              ],
              [
                3.0535909431273995,
                42.43764339682479
              ],
              [
                3.0655798738917874,
                42.43201059369923
              ],
              [
                3.086147094146286,
                42.4271788624494
              ],
              [
                3.1116752507681418,
                42.42500837337443
              ],
              [
                3.1378235270911357,
                42.4259386251732
              ],
              [
                3.1809696573496855,
                42.43148417822645
              ],
              [
                3.1787215493185963,
                42.41799547174695
              ],
              [
                3.170176630338863,
                42.396592590403195
              ],
              [
                3.174489779820521,
                42.3808861248974
              ],
              [
                3.1744897798415503,
                42.36379628207579
              ],
              [
                3.1873478518236844,
                42.349514055103455
              ],
              [
                3.2041935553286987,
                42.339585641517694
              ],
              [
                3.2264917319485806,
                42.34251530870812
              ],
              [
                3.24984785286908,
                42.343207145829396
              ],
              [
                3.263031444714213,
                42.329209632480584
              ],
              [
                3.269867382711513,
                42.329209632480584
              ],
              [
                3.2806095715313863,
                42.336859470975085
              ],
              [
                3.2937117863734815,
                42.334987771604375
              ],
              [
                3.3177189451813254,
                42.32298407282905
              ],
              [
                3.2940373070235105,
                42.288031372676876
              ],
              [
                3.290375197244898,
                42.27806230981852
              ],
              [
                3.2870386082944028,
                42.26292553906118
              ],
              [
                3.2793888681267047,
                42.25564200092759
              ],
              [
                3.270355665651083,
                42.250108175718445
              ],
              [
                3.2630314447063085,
                42.23985416283279
              ],
              [
                3.2471623073004294,
                42.245713680865855
              ],
              [
                3.210134309851439,
                42.23973209977601
              ],
              [
                3.1787215509114413,
                42.249701290444044
              ],
              [
                3.1701766301649585,
                42.25967038091008
              ],
              [
                3.1516219405874195,
                42.25682198351108
              ],
              [
                3.130300324880012,
                42.23973209977601
              ],
              [
                3.118825717156362,
                42.21832917800275
              ],
              [
                3.1174422531053554,
                42.18284734638375
              ],
              [
                3.1164656907398594,
                42.158433319970264
              ],
              [
                3.1224878251649453,
                42.14048895083058
              ],
              [
                3.1386011078580442,
                42.127630918847714
              ],
              [
                3.173106316516275,
                42.112005956328154
              ],
              [
                3.1922985280623632,
                42.092921474522264
              ],
              [
                3.2144956934644724,
                42.06833387208656
              ],
              [
                3.2130092377809425,
                42.05598612090278
              ],
              [
                3.1998595634529514,
                42.04619006110356
              ],
              [
                3.1958961478610943,
                42.03311792070807
              ],
              [
                3.2015893879356097,
                42.01744206386064
              ],
              [
                3.2069604834456875,
                41.9966901961546
              ],
              [
                3.2078556642141742,
                41.99001694964166
              ],
              [
                3.2118432951169535,
                41.98460521659149
              ],
              [
                3.2305607427670613,
                41.97300851793281
              ],
              [
                3.2356876955287617,
                41.965521525603535
              ],
              [
                3.232188347430525,
                41.946031016150336
              ],
              [
                3.2074487640456164,
                41.91392650157944
              ],
              [
                3.1949162130087814,
                41.888291791375465
              ],
              [
                3.1785587888474933,
                41.875230144073335
              ],
              [
                3.1501653777916228,
                41.84535101573485
              ],
              [
                3.116829331250123,
                41.847569168209915
              ],
              [
                3.0786309607018887,
                41.82661831552135
              ],
              [
                3.069057556264826,
                41.79907618713305
              ],
              [
                3.040341038008542,
                41.786890073501915
              ],
              [
                2.9509383466672605,
                41.73427966938714
              ],
              [
                2.9329908500963446,
                41.712464319642606
              ],
              [
                2.9008702389903225,
                41.70670643945362
              ],
              [
                2.8772535397238794,
                41.701957746029386
              ],
              [
                2.8510848313442643,
                41.69717027290264
              ],
              [
                2.840179883490677,
                41.694647495173534
              ],
              [
                2.8354598308706858,
                41.692572260091275
              ],
              [
                2.8201603518254257,
                41.68195220465993
              ],
              [
                2.8170679059350103,
                41.67763912578542
              ],
              [
                2.8131616545244027,
                41.67031481502548
              ],
              [
                2.8037215499146613,
                41.66864654641766
              ],
              [
                2.792002800174582,
                41.669012773449914
              ],
              [
                2.778496577071452,
                41.64558219971679
              ],
              [
                2.6518660830305416,
                41.6052921303627
              ],
              [
                2.4494735048595473,
                41.53522376461243
              ],
              [
                2.4289656919534264,
                41.51894773032027
              ],
              [
                2.371348503957514,
                41.48920318868856
              ],
              [
                2.2967228519417873,
                41.46531809631411
              ],
              [
                2.267344596543952,
                41.448635120829245
              ],
              [
                2.2404077474159942,
                41.420965838780354
              ],
              [
                2.1919051440274897,
                41.356756905318235
              ],
              [
                2.16325931029732,
                41.32664616568836
              ],
              [
                2.130544467083041,
                41.303656324238766
              ],
              [
                2.0603133468295276,
                41.27460356759786
              ],
              [
                2.019704623037488,
                41.26585521344977
              ],
              [
                1.951345247661261,
                41.2606875346798
              ],
              [
                1.8841251958348517,
                41.24750395666741
              ],
              [
                1.8637801441838062,
                41.23810457736674
              ],
              [
                1.854014518768915,
                41.23598865076533
              ],
              [
                1.8198348322064288,
                41.23712801812788
              ],
              [
                1.6243595708887808,
                41.1921654192103
              ],
              [
                1.5392358731685698,
                41.187445400441476
              ],
              [
                1.2880965501952535,
                41.11627841537242
              ],
              [
                1.2177840499283632,
                41.10468169696499
              ],
              [
                1.2100529309298242,
                41.099880265122785
              ],
              [
                1.1924748058040204,
                41.075995153162616
              ],
              [
                1.1886499359455112,
                41.06830474639122
              ],
              [
                1.183604363056046,
                41.06256745887352
              ],
              [
                1.1729435561137933,
                41.05866121820067
              ],
              [
                1.1490991547816578,
                41.0696474923419
              ],
              [
                1.1416935558595431,
                41.071722699908925
              ],
              [
                1.0976668629851358,
                41.070868228444795
              ],
              [
                1.0556746751598867,
                41.06488681440613
              ],
              [
                1.01742597715362,
                41.05178460033704
              ],
              [
                0.9904077481867325,
                41.03969964640964
              ],
              [
                0.8774520190265978,
                40.954779369696084
              ],
              [
                0.8227645189539662,
                40.89960357240603
              ],
              [
                0.714203320925865,
                40.81521228729289
              ],
              [
                0.6948348320498896,
                40.785996825613566
              ],
              [
                0.7215275401314328,
                40.77427809659537
              ],
              [
                0.7501733730586068,
                40.765570394837376
              ],
              [
                0.7623804048802739,
                40.766058631137476
              ],
              [
                0.7672632169648186,
                40.771022845273706
              ],
              [
                0.7635197269968151,
                40.77838776118945
              ],
              [
                0.7501733730538255,
                40.785996825613566
              ],
              [
                0.7669376959751799,
                40.78502024283611
              ],
              [
                0.7805281911531267,
                40.77948643224831
              ],
              [
                0.7920027999094453,
                40.771185592249495
              ],
              [
                0.8159285818913866,
                40.748399130657624
              ],
              [
                0.8418074880982302,
                40.732123136194794
              ],
              [
                0.8541772799162739,
                40.73314034833112
              ],
              [
                0.8737085301518108,
                40.72793206607404
              ],
              [
                0.872406445835426,
                40.707098664032884
              ],
              [
                0.8580835299409301,
                40.68626535385862
              ],
              [
                0.8483179049785248,
                40.67536041415872
              ],
              [
                0.7840275398722427,
                40.660956090864445
              ],
              [
                0.7563582689009507,
                40.64223864894774
              ],
              [
                0.7070418630534793,
                40.58340079747218
              ],
              [
                0.6770939460600869,
                40.56517163400096
              ],
              [
                0.6479598319764789,
                40.5569115190104
              ],
              [
                0.615896030044671,
                40.55345288090487
              ],
              [
                0.5924585299678321,
                40.582098689579766
              ],
              [
                0.6406356129548045,
                40.58685942845659
              ],
              [
                0.6631779310504224,
                40.57473380555812
              ],
              [
                0.6962182950037424,
                40.590358792015884
              ],
              [
                0.7326766290242791,
                40.63373444831477
              ],
              [
                0.7124943368884461,
                40.63617581804861
              ],
              [
                0.6822208989944276,
                40.634222721418176
              ],
              [
                0.5997827479497552,
                40.6137148949512
              ],
              [
                0.580170118024476,
                40.603664463054756
              ],
              [
                0.5634871749451393,
                40.59003325131656
              ],
              [
                0.5485132169858745,
                40.572333070044984
              ],
              [
                0.5174259769964192,
                40.51434967564247
              ],
              [
                0.5013126959892859,
                40.48419830485864
              ],
              [
                0.4834090500006292,
                40.46503327021451
              ],
              [
                0.46615644602157497,
                40.45066967289477
              ],
              [
                0.45264733199030166,
                40.43406809683022
              ],
              [
                0.4461369150435599,
                40.40843335383329
              ],
              [
                0.42025800904069044,
                40.38825106269282
              ],
              [
                0.3505965499894213,
                40.284898173086304
              ],
              [
                0.3389591809949204,
                40.274359439049974
              ],
              [
                0.3121037120029111,
                40.257513740773426
              ],
              [
                0.2988387379999138,
                40.24677155188794
              ],
              [
                0.26474043100590183,
                40.20978425130054
              ],
              [
                0.20525149800405268,
                40.171535552807896
              ],
              [
                0.14454186300005098,
                40.07884349195276
              ],
              [
                0.11703535199993545,
                40.05634186376894
              ],
              [
                0.06617272200046741,
                40.031927803122436
              ],
              [
                0.040497267000066325,
                40.00287506687711
              ],
              [
                -0.002919074999873077,
                39.93195221357769
              ],
              [
                -0.028675910988725208,
                39.901800770590484
              ],
              [
                -0.0912979810605525,
                39.84792728286141
              ],
              [
                -0.19448808498230039,
                39.71544015288413
              ],
              [
                -0.19981848896788482,
                39.704942091928835
              ],
              [
                -0.20213782490986612,
                39.68085349383433
              ],
              [
                -0.2089330718936541,
                39.6640891581052
              ],
              [
                -0.21983802000750424,
                39.651393953897035
              ],
              [
                -0.2437231110988066,
                39.63104897638864
              ],
              [
                -0.25743567619343066,
                39.61623784792532
              ],
              [
                -0.26956132680050243,
                39.59870011332894
              ],
              [
                -0.27489173084898233,
                39.581813758560834
              ],
              [
                -0.28148352821109013,
                39.56936284800022
              ],
              [
                -0.3127335281443065,
                39.53400309009205
              ],
              [
                -0.3233536449077208,
                39.51622136344872
              ],
              [
                -0.3305934767809704,
                39.48040650011711
              ],
              [
                -0.3274715701018847,
                39.43067500008173
              ],
              [
                -0.3206680977860953,
                39.388128837582755
              ],
              [
                -0.30134029891128794,
                39.322007494063946
              ],
              [
                -0.23870140812047103,
                39.215445968398775
              ],
              [
                -0.22781794607205091,
                39.19933570084987
              ],
              [
                -0.2154928239013185,
                39.181838450161095
              ],
              [
                -0.22785736901621614,
                39.17524501166047
              ],
              [
                -0.2421821661233436,
                39.16627528461859
              ],
              [
                -0.23650532307598873,
                39.14805353404254
              ],
              [
                -0.22670336306155084,
                39.11178181091602
              ],
              [
                -0.21002659614523247,
                39.07869033661634
              ],
              [
                -0.18404018812233774,
                39.04225865334536
              ],
              [
                -0.1580297518852466,
                39.00214249483431
              ],
              [
                -0.12067623598257016,
                38.951117225127625
              ],
              [
                -0.10594641806578278,
                38.9365096360284
              ],
              [
                -0.06859290299131564,
                38.91339750196645
              ],
              [
                -0.030995246001666383,
                38.8827578917367
              ],
              [
                -0.009755011999021925,
                38.869696336957
              ],
              [
                0.017425977010141966,
                38.86432538233585
              ],
              [
                0.06308027399831649,
                38.86078521720395
              ],
              [
                0.1110132169824941,
                38.849920933042796
              ],
              [
                0.15398196694573954,
                38.83099999342791
              ],
              [
                0.18531334711622977,
                38.80353437790188
              ],
              [
                0.1810001959686556,
                38.80190660674564
              ],
              [
                0.1709090499946681,
                38.7960879513702
              ],
              [
                0.1828719410859292,
                38.791815595099436
              ],
              [
                0.19076582104676001,
                38.785223751164665
              ],
              [
                0.21786543097688396,
                38.768133833740016
              ],
              [
                0.22771243607609443,
                38.77020912186472
              ],
              [
                0.23406009207686299,
                38.757880018694934
              ],
              [
                0.23454837283997348,
                38.74225480703177
              ],
              [
                0.2277124360415682,
                38.73456455821026
              ],
              [
                0.20899498812999046,
                38.73371015825772
              ],
              [
                0.1920679050586332,
                38.7304141939356
              ],
              [
                0.17676842494851092,
                38.7240257218223
              ],
              [
                0.16260826903533468,
                38.713527781467484
              ],
              [
                0.15088951900793648,
                38.6924502729211
              ],
              [
                0.14893639391969288,
                38.6899273626427
              ],
              [
                0.1450301439788046,
                38.68634671617638
              ],
              [
                0.12574303507085835,
                38.68549237322189
              ],
              [
                0.1185815760676159,
                38.682806827688175
              ],
              [
                0.1053166019570529,
                38.67255271614789
              ],
              [
                0.09367923298310632,
                38.66762926098697
              ],
              [
                0.08301842501863176,
                38.660956168963914
              ],
              [
                0.07313072999053417,
                38.6452090245896
              ],
              [
                0.08057701897042822,
                38.631008127483405
              ],
              [
                0.060435417957743945,
                38.63483292759734
              ],
              [
                0.04664147203015863,
                38.63222904375305
              ],
              [
                0.033376497991434585,
                38.62738673161737
              ],
              [
                0.015025260993389234,
                38.62474183544904
              ],
              [
                -0.014759895009367942,
                38.62441654254689
              ],
              [
                -0.028797981006713574,
                38.62067296876499
              ],
              [
                -0.04295813701692291,
                38.61172117945551
              ],
              [
                -0.054758266998895105,
                38.595282289920064
              ],
              [
                -0.055083787987286595,
                38.580755878535506
              ],
              [
                -0.05361894401928652,
                38.56696205722845
              ],
              [
                -0.06004798099547006,
                38.55272042936637
              ],
              [
                -0.07542883995607082,
                38.53994362906425
              ],
              [
                -0.09019934797537245,
                38.53534571237837
              ],
              [
                -0.13174394396405034,
                38.53534571237837
              ],
              [
                -0.17699134006017397,
                38.52724851204869
              ],
              [
                -0.20213782513376313,
                38.51959884018484
              ],
              [
                -0.23395748600778857,
                38.50165437109742
              ],
              [
                -0.32941646989156453,
                38.47003808318051
              ],
              [
                -0.344553188773218,
                38.46161516231081
              ],
              [
                -0.35081946496825883,
                38.45001860283461
              ],
              [
                -0.35871334478956296,
                38.44594948640417
              ],
              [
                -0.39517167925149854,
                38.4137638744404
              ],
              [
                -0.4060766269792294,
                38.398871150137666
              ],
              [
                -0.4101456368338494,
                38.37933982471868
              ],
              [
                -0.40998287675096245,
                38.36896380452203
              ],
              [
                -0.41368567625852437,
                38.36481367729068
              ],
              [
                -0.44587154884295066,
                38.363430004910576
              ],
              [
                -0.46019446485037035,
                38.36005273268927
              ],
              [
                -0.47057044215415955,
                38.35187416092837
              ],
              [
                -0.47435462109005333,
                38.3367374125729
              ],
              [
                -0.5098363922099893,
                38.33836506395731
              ],
              [
                -0.5187882150992928,
                38.298651474974534
              ],
              [
                -0.5040177068842975,
                38.20722072071008
              ],
              [
                -0.515451626806822,
                38.19550193947079
              ],
              [
                -0.5328669911937159,
                38.19216551017392
              ],
              [
                -0.5688370431600469,
                38.19419999750814
              ],
              [
                -0.5913793613307546,
                38.18964276526066
              ],
              [
                -0.6094864573341612,
                38.17804608395507
              ],
              [
                -0.6236873036829467,
                38.16242085659494
              ],
              [
                -0.6343888011876831,
                38.145819466753586
              ],
              [
                -0.6407364570206391,
                38.13165925396212
              ],
              [
                -0.6450089182755887,
                38.11603433919962
              ],
              [
                -0.6480199858854128,
                38.07379788079558
              ],
              [
                -0.6524958979123576,
                38.00775785090319
              ],
              [
                -0.6545304030956389,
                37.98932529373625
              ],
              [
                -0.6634008453844354,
                37.9802921848115
              ],
              [
                -0.6899307929726604,
                37.972154030420874
              ],
              [
                -0.7088516922785734,
                37.95628498342424
              ],
              [
                -0.7184138659526351,
                37.943019909683116
              ],
              [
                -0.7586156888053601,
                37.86334864401697
              ],
              [
                -0.760731574854469,
                37.84707261624322
              ],
              [
                -0.7605688142435392,
                37.84585202495418
              ],
              [
                -0.756092902964467,
                37.806057022742465
              ],
              [
                -0.760731574616115,
                37.79612853755357
              ],
              [
                -0.7879939445152725,
                37.82282149899623
              ],
              [
                -0.8124080067126079,
                37.77008690348314
              ],
              [
                -0.8255509110360822,
                37.76137930860033
              ],
              [
                -0.8478083981626917,
                37.75608962710568
              ],
              [
                -0.8561091794033109,
                37.742499194402946
              ],
              [
                -0.8526098300621032,
                37.72378165901165
              ],
              [
                -0.8198136058069285,
                37.676703140186085
              ],
              [
                -0.8099259115368441,
                37.66689702297901
              ],
              [
                -0.7776993481959646,
                37.65009191954716
              ],
              [
                -0.7547908185355968,
                37.64130266637236
              ],
              [
                -0.7348526681167371,
                37.63934971205072
              ],
              [
                -0.7264705068284949,
                37.65151596599771
              ],
              [
                -0.7079972000654337,
                37.643011806402406
              ],
              [
                -0.7012426416121476,
                37.63133360402183
              ],
              [
                -0.7053116527002505,
                37.619533502240785
              ],
              [
                -0.719715950163116,
                37.61054113306358
              ],
              [
                -0.7278946611366705,
                37.603420356485046
              ],
              [
                -0.736643032888517,
                37.59943265058675
              ],
              [
                -0.7456762358871517,
                37.59943265058675
              ],
              [
                -0.7545059887469967,
                37.604315422967495
              ],
              [
                -0.764027472806702,
                37.59959538913428
              ],
              [
                -0.791493292532409,
                37.59145729348534
              ],
              [
                -0.8079727860217902,
                37.58844636197737
              ],
              [
                -0.8364151681963239,
                37.576402136921665
              ],
              [
                -0.8738907542051516,
                37.576402136921665
              ],
              [
                -0.8867081373726421,
                37.57428629295356
              ],
              [
                -0.9006241532479836,
                37.56903723792486
              ],
              [
                -0.9251602858860778,
                37.55589424576272
              ],
              [
                -0.9337052067789477,
                37.56102117362878
              ],
              [
                -0.9735001292285419,
                37.576402136921665
              ],
              [
                -1.0064184233522169,
                37.58144751572495
              ],
              [
                -1.0699356759181347,
                37.582586964098326
              ],
              [
                -1.087757941733128,
                37.580877942775416
              ],
              [
                -1.103423632259037,
                37.576402136921665
              ],
              [
                -1.1146541016199254,
                37.568671089030886
              ],
              [
                -1.119984504020282,
                37.559027415018306
              ],
              [
                -1.1168513659538195,
                37.549383846859094
              ],
              [
                -1.1057666884147048,
                37.53213501809911
              ],
              [
                -1.1371719404417238,
                37.53800070905401
              ],
              [
                -1.1670574806067986,
                37.54375524141001
              ],
              [
                -1.1734084769167266,
                37.55507577230223
              ],
              [
                -1.1785853264560742,
                37.56388344261889
              ],
              [
                -1.1997320677383752,
                37.56656460577071
              ],
              [
                -1.2289932935751593,
                37.576076668495354
              ],
              [
                -1.2426988673264643,
                37.57920267718536
              ],
              [
                -1.2576668025761373,
                37.56701332545751
              ],
              [
                -1.261670587636017,
                37.55766137957395
              ],
              [
                -1.289784309669632,
                37.558417173905454
              ],
              [
                -1.323735141668226,
                37.56199093270266
              ],
              [
                -1.3532608703215825,
                37.54991271703288
              ],
              [
                -1.369170702344575,
                37.5413679617498
              ],
              [
                -1.4136856763033088,
                37.506537224598404
              ],
              [
                -1.4303686190036295,
                37.4981143255754
              ],
              [
                -1.450225389714426,
                37.49469631230546
              ],
              [
                -1.4555557930761982,
                37.492702552631684
              ],
              [
                -1.4634903641666468,
                37.487982514287815
              ],
              [
                -1.470895963227969,
                37.48224521842732
              ],
              [
                -1.4741104805409375,
                37.477606442848646
              ],
              [
                -1.476673957460419,
                37.47272376927213
              ],
              [
                -1.4872940753105581,
                37.439764762467945
              ],
              [
                -1.4883520171588345,
                37.43321363275597
              ],
              [
                -1.4969376288347054,
                37.427801800429215
              ],
              [
                -1.5027970036468807,
                37.42926661670793
              ],
              [
                -1.5081680983000387,
                37.432684681282225
              ],
              [
                -1.5150040361616621,
                37.43321363275597
              ],
              [
                -1.523915167979144,
                37.428656313965924
              ],
              [
                -1.543731249373534,
                37.414984495897045
              ],
              [
                -1.5529679027531134,
                37.41217678960093
              ],
              [
                -1.567738410911461,
                37.40993885642795
              ],
              [
                -1.6187231108252795,
                37.392279339942405
              ],
              [
                -1.6416177133573397,
                37.381036495560075
              ],
              [
                -1.6459134430349327,
                37.36924709974673
              ],
              [
                -1.6528389420131007,
                37.361259188775065
              ],
              [
                -1.6708878245044345,
                37.36330794380312
              ],
              [
                -1.680165168405461,
                37.35443762090423
              ],
              [
                -1.6857804028355337,
                37.33698149020731
              ],
              [
                -1.6989639957315168,
                37.31643297465967
              ],
              [
                -1.7285050115794918,
                37.28241602850673
              ],
              [
                -1.787220832321747,
                37.235215602424766
              ],
              [
                -1.8127335275543546,
                37.207057954748336
              ],
              [
                -1.830352342859065,
                37.166367888665334
              ],
              [
                -1.837757942085682,
                37.13161856752293
              ],
              [
                -1.8498429036074462,
                37.10443764116216
              ],
              [
                -1.8552139960807628,
                37.076605545852175
              ],
              [
                -1.8849991528262795,
                37.01548897811889
              ],
              [
                -1.9061173164530665,
                36.987616212881356
              ],
              [
                -1.9069718093144854,
                36.97528721446114
              ],
              [
                -1.904164192457844,
                36.966376098631535
              ],
              [
                -1.9005020818380294,
                36.958766974638586
              ],
              [
                -1.8986710278038934,
                36.95005928852941
              ],
              [
                -1.9003393223015592,
                36.94118890509967
              ],
              [
                -1.905222134611002,
                36.93598060896207
              ],
              [
                -1.9128718743225757,
                36.93353916837008
              ],
              [
                -1.9352921208079035,
                36.93219633342616
              ],
              [
                -1.9413956369889627,
                36.92987701871646
              ],
              [
                -1.9538468085433232,
                36.91994858180313
              ],
              [
                -1.9889216783988986,
                36.900498696150976
              ],
              [
                -2.0027970042458696,
                36.88703036899249
              ],
              [
                -2.0130509105088517,
                36.845770519287555
              ],
              [
                -2.0247696608427366,
                36.83376697626009
              ],
              [
                -2.040476040627296,
                36.82432684825617
              ],
              [
                -2.0568741531321875,
                36.8100853687096
              ],
              [
                -2.060739712631468,
                36.80243557309072
              ],
              [
                -2.0659073557776853,
                36.78355538136772
              ],
              [
                -2.071156378438532,
                36.77533594290688
              ],
              [
                -2.0803116533082755,
                36.77061598696261
              ],
              [
                -2.0914200511352594,
                36.76825594182575
              ],
              [
                -2.100819464934606,
                36.76516347187565
              ],
              [
                -2.1110733706183793,
                36.746120468547
              ],
              [
                -2.126698370852936,
                36.736395559141556
              ],
              [
                -2.146717902885538,
                36.72992583577163
              ],
              [
                -2.166127082579466,
                36.72756588341216
              ],
              [
                -2.2036433577309262,
                36.737127968992674
              ],
              [
                -2.2316788405645602,
                36.76007727399698
              ],
              [
                -2.25613359226632,
                36.78738020154983
              ],
              [
                -2.2827856111467573,
                36.8100853687096
              ],
              [
                -2.3183487619339207,
                36.82790761249422
              ],
              [
                -2.339141404688195,
                36.834255245551674
              ],
              [
                -2.3616837228680807,
                36.83677804924409
              ],
              [
                -2.3802384108151386,
                36.83376697626009
              ],
              [
                -2.4127091144090036,
                36.82001377776359
              ],
              [
                -2.4330948564113224,
                36.816270287665496
              ],
              [
                -2.4423315093193327,
                36.81830478490248
              ],
              [
                -2.4693904289789,
                36.827744857053695
              ],
              [
                -2.481434700097389,
                36.829942132977735
              ],
              [
                -2.560780403120603,
                36.81879304677633
              ],
              [
                -2.576893684363582,
                36.8113060892783
              ],
              [
                -2.5967097642704418,
                36.773097984638355
              ],
              [
                -2.617176887734775,
                36.728420379450334
              ],
              [
                -2.642689582826068,
                36.70701739182102
              ],
              [
                -2.647572394658366,
                36.70416898235552
              ],
              [
                -2.6588842438771327,
                36.69481027838455
              ],
              [
                -2.6843562486127395,
                36.6859805028285
              ],
              [
                -2.7182511068516684,
                36.68203366806852
              ],
              [
                -2.73619544279871,
                36.687404757126636
              ],
              [
                -2.756662563345748,
                36.68036524741415
              ],
              [
                -2.782948371725735,
                36.69460689795251
              ],
              [
                -2.8026016928189637,
                36.70730221814039
              ],
              [
                -2.8209936183201423,
                36.71389389165354
              ],
              [
                -2.82998613184401,
                36.71173735934439
              ],
              [
                -2.8390600255737857,
                36.70241938444858
              ],
              [
                -2.8482559890878254,
                36.70022207909145
              ],
              [
                -2.858754036528249,
                36.704942166462594
              ],
              [
                -2.8860977855074474,
                36.73440172084147
              ],
              [
                -2.9139705069279147,
                36.75031158533259
              ],
              [
                -2.933257615565816,
                36.751654330062806
              ],
              [
                -2.9877189346652813,
                36.7371090000979
              ],
              [
                -3.076453404695759,
                36.74975621132583
              ],
              [
                -3.1567111717363376,
                36.744525713847516
              ],
              [
                -3.2278946612076513,
                36.75482820675401
              ],
              [
                -3.3295792312662056,
                36.74489982534504
              ],
              [
                -3.344390429499953,
                36.73692458030591
              ],
              [
                -3.3583064435585324,
                36.72593818782728
              ],
              [
                -3.37877356618575,
                36.71389389165354
              ],
              [
                -3.415154669406856,
                36.69551631438779
              ],
              [
                -3.477602128802984,
                36.696096047078036
              ],
              [
                -3.5159625474641616,
                36.72104653531492
              ],
              [
                -3.5360603648241975,
                36.71840644052947
              ],
              [
                -3.549831564466288,
                36.712372651470766
              ],
              [
                -3.586401548255233,
                36.72657920933239
              ],
              [
                -3.6011001729438292,
                36.74255022672274
              ],
              [
                -3.6324198839864525,
                36.741279605992354
              ],
              [
                -3.665666698197542,
                36.73937036577981
              ],
              [
                -3.679822364091326,
                36.72880788369909
              ],
              [
                -3.7312813299868157,
                36.724097323192375
              ],
              [
                -3.8034330532444756,
                36.742474350749134
              ],
              [
                -3.838541254122707,
                36.751969880596505
              ],
              [
                -3.8894447450062515,
                36.743388325395834
              ],
              [
                -3.9609611249329766,
                36.726792833073475
              ],
              [
                -4.056711391640048,
                36.747992234653
              ],
              [
                -4.07995794952179,
                36.74356416511724
              ],
              [
                -4.110172196836059,
                36.725732693698944
              ],
              [
                -4.197010870936252,
                36.71539947751614
              ],
              [
                -4.224720832818552,
                36.71238845850728
              ],
              [
                -4.403187630004128,
                36.7238630753582
              ],
              [
                -4.420318164109669,
                36.71987545064731
              ],
              [
                -4.433257617243414,
                36.71067949343187
              ],
              [
                -4.46117102768202,
                36.67145415260386
              ],
              [
                -4.4668676420919695,
                36.663031321741705
              ],
              [
                -4.480458137402237,
                36.65119051767987
              ],
              [
                -4.4911189452608316,
                36.636664194697794
              ],
              [
                -4.495350715625325,
                36.62055088008233
              ],
              [
                -4.524826051527925,
                36.58071518885412
              ],
              [
                -4.587799795318441,
                36.57381772740698
              ],
              [
                -4.615021325289143,
                36.53055572534747
              ],
              [
                -4.649810351940502,
                36.51211176786304
              ],
              [
                -4.659250454081439,
                36.50763576332051
              ],
              [
                -4.680287239060743,
                36.500799875011346
              ],
              [
                -4.7227677066431495,
                36.492987354483425
              ],
              [
                -4.76423092286721,
                36.4939638788757
              ],
              [
                -4.880319791147746,
                36.50568269101936
              ],
              [
                -4.902658657634392,
                36.506537159721795
              ],
              [
                -4.912180142092226,
                36.50401439435332
              ],
              [
                -4.923532681792392,
                36.49685296931287
              ],
              [
                -4.994166374004814,
                36.45709391173143
              ],
              [
                -5.0624893856821815,
                36.45221582654413
              ],
              [
                -5.108713344968241,
                36.42902252655679
              ],
              [
                -5.1210424456663,
                36.42556380844641
              ],
              [
                -5.157622850061619,
                36.421942407691475
              ],
              [
                -5.173654751647912,
                36.41742583217286
              ],
              [
                -5.186553516569787,
                36.411200332421146
              ],
              [
                -5.199655726713808,
                36.39716211941728
              ],
              [
                -5.227121550017551,
                36.357936961396426
              ],
              [
                -5.227935349633577,
                36.34853744103109
              ],
              [
                -5.2446996742378,
                36.31207917959578
              ],
              [
                -5.25365149730186,
                36.297105267935585
              ],
              [
                -5.258615689860548,
                36.29254795726717
              ],
              [
                -5.265939907674639,
                36.2870954305516
              ],
              [
                -5.274118619146778,
                36.28253815951372
              ],
              [
                -5.290598110454601,
                36.277411175881866
              ],
              [
                -5.289499476721034,
                36.26984278441135
              ],
              [
                -5.28530839843644,
                36.26080965633757
              ],
              [
                -5.296620246143872,
                36.247381909367235
              ],
              [
                -5.329335089508845,
                36.19814685536879
              ],
              [
                -5.334055141526585,
                36.187811570158054
              ],
              [
                -5.338773483766224,
                36.14111969507833
              ],
              [
                -5.358386758834612,
                36.14110946338926
              ],
              [
                -5.366607226061283,
                36.16315338968793
              ],
              [
                -5.382517055149,
                36.17230862384784
              ],
              [
                -5.406076626880924,
                36.17922597382753
              ],
              [
                -5.425445116096502,
                36.17975495418161
              ],
              [
                -5.428700325747918,
                36.16998935738418
              ],
              [
                -5.43789628742284,
                36.16148506804901
              ],
              [
                -5.442331509441853,
                36.14878980010156
              ],
              [
                -5.441477017378623,
                36.13454826037962
              ],
              [
                -5.434885219161754,
                36.12152737467951
              ],
              [
                -5.4398901033551175,
                36.11420320738159
              ],
              [
                -5.437163865468959,
                36.098700238979895
              ],
              [
                -5.431630011762102,
                36.088934626675176
              ],
              [
                -5.428700324640633,
                36.08079660138807
              ],
              [
                -5.431833462628903,
                36.069566131879675
              ],
              [
                -5.43862871033514,
                36.06281160555045
              ],
              [
                -5.4455053376024,
                36.05744047976297
              ],
              [
                -5.4665014313097195,
                36.05072664338541
              ],
              [
                -5.566599087315094,
                36.0216331759079
              ],
              [
                -5.581003383235565,
                36.01398343360261
              ],
              [
                -5.61176510376713,
                36.006455828349864
              ],
              [
                -5.6297094393268905,
                36.03676993772442
              ],
              [
                -5.671701626809189,
                36.05597564505781
              ],
              [
                -5.689361132011162,
                36.06712474246602
              ],
              [
                -5.713124152114465,
                36.059963246407875
              ],
              [
                -5.733876105954312,
                36.06565989612288
              ],
              [
                -5.753651495604497,
                36.075588266784365
              ],
              [
                -5.796050584370281,
                36.08551664337829
              ],
              [
                -5.811268683785848,
                36.09682850931618
              ],
              [
                -5.832753059736424,
                36.122381932736246
              ],
              [
                -5.897897915531745,
                36.1738955563466
              ],
              [
                -5.9171850258653045,
                36.18406813535244
              ],
              [
                -5.938954231895986,
                36.18382399544089
              ],
              [
                -5.983550585003751,
                36.17698802315
              ],
              [
                -6.036773240521022,
                36.18952055636988
              ],
              [
                -6.062489387483627,
                36.21723055471551
              ],
              [
                -6.082183397768866,
                36.250677793101374
              ],
              [
                -6.104725714264509,
                36.28070706981786
              ],
              [
                -6.159453906150217,
                36.30430740264722
              ],
              [
                -6.165964322034996,
                36.318711657328734
              ],
              [
                -6.168527800142252,
                36.33531326122345
              ],
              [
                -6.175200974689019,
                36.353583025488625
              ],
              [
                -6.184193490886585,
                36.37071368010151
              ],
              [
                -6.218373175785962,
                36.40245188199083
              ],
              [
                -6.242054815412012,
                36.44647852390044
              ],
              [
                -6.2571101538902365,
                36.47642645785187
              ],
              [
                -6.279611783401313,
                36.51129793380788
              ],
              [
                -6.301421679848862,
                36.525987077192696
              ],
              [
                -6.310007291988463,
                36.53412510326039
              ],
              [
                -6.297678190028449,
                36.538763776792216
              ],
              [
                -6.2893774089614105,
                36.537298930377844
              ],
              [
                -6.257517057671776,
                36.51378007689232
              ],
              [
                -6.248972133539907,
                36.50474679494007
              ],
              [
                -6.2540990882239935,
                36.49628327830608
              ],
              [
                -6.246652797655825,
                36.486639666096266
              ],
              [
                -6.23147538914374,
                36.47268297811468
              ],
              [
                -6.219064909044325,
                36.474961694966325
              ],
              [
                -6.211496547462732,
                36.48053614258945
              ],
              [
                -6.200754359643444,
                36.49384181327909
              ],
              [
                -6.179351367794875,
                36.51353594129052
              ],
              [
                -6.186472132734789,
                36.51422755862738
              ],
              [
                -6.206817187581592,
                36.50889722471273
              ],
              [
                -6.224354620321794,
                36.51085030275885
              ],
              [
                -6.232451950075341,
                36.52619042550337
              ],
              [
                -6.226022915442641,
                36.556667364302946
              ],
              [
                -6.234893358249711,
                36.57575105325692
              ],
              [
                -6.283192512626453,
                36.61237216000307
              ],
              [
                -6.293853317575363,
                36.61684799679641
              ],
              [
                -6.361724413885,
                36.62055088008233
              ],
              [
                -6.379790818383191,
                36.62425362571089
              ],
              [
                -6.394683396271182,
                36.636908207702376
              ],
              [
                -6.406971810664038,
                36.67670325175202
              ],
              [
                -6.417632614878438,
                36.6959495708318
              ],
              [
                -6.431548630877369,
                36.714585638912766
              ],
              [
                -6.43789628961065,
                36.733303184416656
              ],
              [
                -6.433338995306746,
                36.75120674829243
              ],
              [
                -6.414540168894849,
                36.767645606970135
              ],
              [
                -6.39631100293742,
                36.775091897574406
              ],
              [
                -6.358876104887575,
                36.7858340119472
              ],
              [
                -6.34561113367246,
                36.79498938532628
              ],
              [
                -6.335194466913458,
                36.818264134063206
              ],
              [
                -6.343739387316985,
                36.859930742407705
              ],
              [
                -6.338205532426161,
                36.88373442135953
              ],
              [
                -6.3043513672089695,
                36.90721267568083
              ],
              [
                -6.2232559881995515,
                36.9023297907001
              ],
              [
                -6.194813607267479,
                36.93211502255479
              ],
              [
                -6.214019333427237,
                36.921698251391106
              ],
              [
                -6.2396541026200385,
                36.91339758712348
              ],
              [
                -6.2650447268934135,
                36.912909279475
              ],
              [
                -6.283558724812508,
                36.92593014564887
              ],
              [
                -6.325917119456837,
                36.912665050453874
              ],
              [
                -6.344715950030225,
                36.901271878088636
              ],
              [
                -6.3524470672627755,
                36.880275720640995
              ],
              [
                -6.3466690751522306,
                36.81989167448732
              ],
              [
                -6.3524470683133405,
                36.808579795276586
              ],
              [
                -6.388010221974753,
                36.80817298971571
              ],
              [
                -6.416249150965824,
                36.8377952425749
              ],
              [
                -6.4486384753741275,
                36.90420154289372
              ],
              [
                -6.471099411064815,
                36.93561425697255
              ],
              [
                -6.4995824858430815,
                36.959662171515305
              ],
              [
                -6.74486243499467,
                37.101385842307955
              ],
              [
                -6.771473763333219,
                37.11277908344602
              ],
              [
                -6.794667122787267,
                37.117743290365226
              ],
              [
                -6.811756966009982,
                37.123724710455505
              ],
              [
                -6.853016729161741,
                37.15110905655571
              ],
              [
                -6.873280404339146,
                37.15867751989354
              ],
              [
                -6.892893033291204,
                37.166571365515395
              ],
              [
                -6.910878059279679,
                37.18895092310743
              ],
              [
                -6.91763261432633,
                37.215073905634966
              ],
              [
                -6.910755987380818,
                37.227606459381775
              ],
              [
                -6.898752409102477,
                37.23578525887945
              ],
              [
                -6.8641251267876715,
                37.27753319777703
              ],
              [
                -6.85269120893023,
                37.295233431047265
              ],
              [
                -6.903472458631341,
                37.24957912451984
              ],
              [
                -6.9311417313123,
                37.23387279911946
              ],
              [
                -6.9625544920220905,
                37.23383213096194
              ],
              [
                -6.96255448936868,
                37.227606459381775
              ],
              [
                -6.940744594360118,
                37.20066964327173
              ],
              [
                -6.930083786621174,
                37.1831728742301
              ],
              [
                -6.928456182830046,
                37.17234931298589
              ],
              [
                -6.9416397771447285,
                37.171087930262665
              ],
              [
                -7.029367644222859,
                37.205511857090734
              ],
              [
                -7.061675584410855,
                37.21393461825399
              ],
              [
                -7.101040417357132,
                37.2242507622994
              ],
              [
                -7.127349412249206,
                37.21474841633073
              ],
              [
                -7.098988413193877,
                37.211900201456764
              ],
              [
                -7.0855606749832445,
                37.20648831574431
              ],
              [
                -7.327870248216033,
                37.20156491399846
              ],
              [
                -7.343088344307138,
                37.19623442078096
              ],
              [
                -7.362904428373371,
                37.18170814754259
              ],
              [
                -7.381418421855797,
                37.17991764462461
              ],
              [
                -7.398508265736142,
                37.18545152656457
              ],
              [
                -7.414418098250344,
                37.192816480596555
              ],
              [
                -7.4293867612331965,
                37.23674638548254
              ],
              [
                -7.434244341800874,
                37.25932885266255
              ],
              [
                -7.427578084672771,
                37.27452181030178
              ],
              [
                -7.437448280518014,
                37.30733624931845
              ],
              [
                -7.444993043719514,
                37.38676305250807
              ],
              [
                -7.462252970820774,
                37.41787220765492
              ],
              [
                -7.460030883367545,
                37.42913765613354
              ],
              [
                -7.4629247641895535,
                37.4511260026519
              ],
              [
                -7.4688675515984455,
                37.4755688785838
              ],
              [
                -7.475947227021386,
                37.49425004000959
              ],
              [
                -7.481476601786712,
                37.500373572365646
              ],
              [
                -7.4986331784076805,
                37.511664920486794
              ],
              [
                -7.506332970532385,
                37.5181245667959
              ],
              [
                -7.514613426075592,
                37.528333866254954
              ],
              [
                -7.515428017875721,
                37.52933824385453
              ],
              [
                -7.517546752462368,
                37.53517769915974
              ],
              [
                -7.51842525729639,
                37.541947453554684
              ],
              [
                -7.52367040688033,
                37.55566732723433
              ],
              [
                -7.527597821395017,
                37.55551243201751
              ],
              [
                -7.529122274653755,
                37.55670096722045
              ],
              [
                -7.529690717876035,
                37.56716551049405
              ],
              [
                -7.526486775162786,
                37.57119616340081
              ],
              [
                -7.515841434941788,
                37.58093731094387
              ],
              [
                -7.514652877183478,
                37.5858724170448
              ],
              [
                -7.512534139592173,
                37.59036816142246
              ],
              [
                -7.511758992941867,
                37.59527740329204
              ],
              [
                -7.514342818229475,
                37.60140118631518
              ],
              [
                -7.504886030547911,
                37.60638794238979
              ],
              [
                -7.478479371293669,
                37.628867124162035
              ],
              [
                -7.471606405952482,
                37.63690279911258
              ],
              [
                -7.466335410906952,
                37.65196653779748
              ],
              [
                -7.457550414952615,
                37.70007720860587
              ],
              [
                -7.444011190618829,
                37.730152911256525
              ],
              [
                -7.426337848438067,
                37.75061671486277
              ],
              [
                -7.334405479170684,
                37.81193091174927
              ],
              [
                -7.3068619402189015,
                37.85076575231566
              ],
              [
                -7.295803178976703,
                37.884872040653015
              ],
              [
                -7.27389237421186,
                37.931535926428545
              ],
              [
                -7.268621379868025,
                37.94923515396469
              ],
              [
                -7.26908646993663,
                37.95944134167805
              ],
              [
                -7.272135375918536,
                37.96894968456892
              ],
              [
                -7.272703817511325,
                37.97701122526809
              ],
              [
                -7.265830846486463,
                37.98295386616795
              ],
              [
                -7.234049840041461,
                37.98806981825739
              ],
              [
                -7.223301148565532,
                37.99383193602376
              ],
              [
                -7.2103303604425,
                37.99303082704838
              ],
              [
                -7.197617964321525,
                37.98993041913701
              ],
              [
                -7.185267291817073,
                37.98869001807759
              ],
              [
                -7.172864951554586,
                37.99383193602376
              ],
              [
                -7.159739136940416,
                37.99680331249467
              ],
              [
                -7.152246057152629,
                38.000653303922185
              ],
              [
                -7.141910770135995,
                38.01158286853886
              ],
              [
                -7.131988894577219,
                38.03238258525817
              ],
              [
                -7.123255575603061,
                38.040004829723095
              ],
              [
                -7.105943971186477,
                38.03866123015225
              ],
              [
                -7.049358272225597,
                38.02021259198567
              ],
              [
                -7.0239851442658745,
                38.02256383897573
              ],
              [
                -7.015768592179692,
                38.04682598400506
              ],
              [
                -7.006363482317161,
                38.05933168418105
              ],
              [
                -6.997630164631968,
                38.08961405204367
              ],
              [
                -6.978974976219278,
                38.11994822877804
              ],
              [
                -6.965487427524172,
                38.153331213208645
              ],
              [
                -6.9576326061552045,
                38.168162214081136
              ],
              [
                -6.94750402326126,
                38.19663590040985
              ],
              [
                -6.950575763733745,
                38.198386003446814
              ],
              [
                -6.9641955214929725,
                38.2061446495973
              ],
              [
                -6.992100789604299,
                38.204284147843396
              ],
              [
                -7.018145711884934,
                38.19803133810109
              ],
              [
                -7.02103958898161,
                38.19823792461374
              ],
              [
                -7.02641394275159,
                38.1996333651538
              ],
              [
                -7.0387129270169595,
                38.18622312432542
              ],
              [
                -7.063052528943911,
                38.17754154338233
              ],
              [
                -7.088322304726555,
                38.173381583997255
              ],
              [
                -7.103515180519809,
                38.173588465610884
              ],
              [
                -7.117068156669359,
                38.18363314601003
              ],
              [
                -7.126872928359098,
                38.190900065329195
              ],
              [
                -7.167180540213506,
                38.272083585619605
              ],
              [
                -7.1723998646683444,
                38.27652789166224
              ],
              [
                -7.189453083108237,
                38.28652714568832
              ],
              [
                -7.196326049787866,
                38.2921599266949
              ],
              [
                -7.200666871228809,
                38.29838694980024
              ],
              [
                -7.207126422616189,
                38.31169355329453
              ],
              [
                -7.211363894541492,
                38.317533136321366
              ],
              [
                -7.31714554315365,
                38.42458065016267
              ],
              [
                -7.345515904926965,
                38.440962073254624
              ],
              [
                -7.359210166912185,
                38.4463624910657
              ],
              [
                -7.34484411753739,
                38.45832554544315
              ],
              [
                -7.335180622966465,
                38.46943590410519
              ],
              [
                -7.3340954141219115,
                38.48101134285753
              ],
              [
                -7.345619267895993,
                38.49413740927303
              ],
              [
                -7.335800737027124,
                38.50586770427805
              ],
              [
                -7.317713992746901,
                38.556252448211325
              ],
              [
                -7.275856079612726,
                38.60382048477888
              ],
              [
                -7.270430052165592,
                38.61769556483735
              ],
              [
                -7.273530641148015,
                38.62539543924956
              ],
              [
                -7.279421752844586,
                38.628909399506774
              ],
              [
                -7.286036340432655,
                38.6319067651132
              ],
              [
                -7.290945598878629,
                38.63815953924463
              ],
              [
                -7.2924958893734075,
                38.64611763792054
              ],
              [
                -7.292960978729428,
                38.65627209504071
              ],
              [
                -7.290945592747684,
                38.67908709646059
              ],
              [
                -7.284072630695091,
                38.71324530342198
              ],
              [
                -7.280713661978741,
                38.72042830778601
              ],
              [
                -7.272187048105726,
                38.73373490596376
              ],
              [
                -7.270430054175913,
                38.73750743207381
              ],
              [
                -7.225878380701713,
                38.76613370353641
              ],
              [
                -7.211518925606498,
                38.77536054659852
              ],
              [
                -7.19642939876721,
                38.779985331014814
              ],
              [
                -7.1797379188639,
                38.79088929247594
              ],
              [
                -7.16619868563347,
                38.80342058773354
              ],
              [
                -7.160617632384651,
                38.812903264749
              ],
              [
                -7.151005815775205,
                38.81928528588287
              ],
              [
                -7.104858767939312,
                38.82719196031243
              ],
              [
                -7.0886840456928475,
                38.83336734708128
              ],
              [
                -7.0765400795371605,
                38.8432373923683
              ],
              [
                -7.064292765334301,
                38.851118072863414
              ],
              [
                -7.056076208799537,
                38.85514869996993
              ],
              [
                -7.057264769494386,
                38.86943734208492
              ],
              [
                -7.0522004810259125,
                38.88499199426835
              ],
              [
                -7.066049767977084,
                38.90460325757924
              ],
              [
                -7.044500690860461,
                38.91863328740205
              ],
              [
                -7.02212479576329,
                38.94286953146252
              ],
              [
                -6.988638463240716,
                38.99377071305298
              ],
              [
                -6.97881995059857,
                39.00382205631845
              ],
              [
                -6.973290569168119,
                39.0139505356396
              ],
              [
                -6.974892537730295,
                39.02301970700954
              ],
              [
                -6.98631303156919,
                39.0300736229857
              ],
              [
                -6.97938838468884,
                39.047178378641526
              ],
              [
                -6.985692909042166,
                39.0667637276743
              ],
              [
                -6.99969722611806,
                39.084695539478375
              ],
              [
                -7.015768592974954,
                39.096813600557475
              ],
              [
                -7.038816281632465,
                39.109138419771234
              ],
              [
                -7.064912884543332,
                39.11477126495344
              ],
              [
                -7.091267864720572,
                39.11244583093563
              ],
              [
                -7.115194055145737,
                39.10110292397742
              ],
              [
                -7.127286337134713,
                39.09748545689624
              ],
              [
                -7.142530884811382,
                39.09952669639533
              ],
              [
                -7.157206990438701,
                39.10544360785833
              ],
              [
                -7.167490606114299,
                39.11347945683952
              ],
              [
                -7.16888586486259,
                39.121850888060806
              ],
              [
                -7.157930462597976,
                39.14138462888185
              ],
              [
                -7.155811722430094,
                39.151513031823114
              ],
              [
                -7.168059035905955,
                39.17063329716218
              ],
              [
                -7.191571818041107,
                39.17916005617416
              ],
              [
                -7.219322065092601,
                39.18484452144722
              ],
              [
                -7.2441267531563325,
                39.195644926309704
              ],
              [
                -7.258079383485974,
                39.21130269584158
              ],
              [
                -7.26577917901324,
                39.23135336502192
              ],
              [
                -7.264332237197139,
                39.25233397296516
              ],
              [
                -7.250844688836624,
                39.270627419897544
              ],
              [
                -7.3004540612886215,
                39.31791128305763
              ],
              [
                -7.31926428307098,
                39.32953847497666
              ],
              [
                -7.3266540168135075,
                39.34132083271457
              ],
              [
                -7.331408249107776,
                39.36261153165051
              ],
              [
                -7.3319250063637185,
                39.38472882897792
              ],
              [
                -7.326705686110323,
                39.398836487955414
              ],
              [
                -7.318850875125773,
                39.41325440733198
              ],
              [
                -7.313631546961736,
                39.436095164143396
              ],
              [
                -7.313528196242633,
                39.457437594374376
              ],
              [
                -7.320917932266524,
                39.46741131188723
              ],
              [
                -7.362930871923606,
                39.476092970208306
              ],
              [
                -7.384169886101793,
                39.48399946864506
              ],
              [
                -7.399414424400018,
                39.49366269541496
              ],
              [
                -7.408922889315749,
                39.515573555890136
              ],
              [
                -7.417552856912098,
                39.52420359061118
              ],
              [
                -7.451349245652572,
                39.53784624376194
              ],
              [
                -7.468092406286113,
                39.55024849574541
              ],
              [
                -7.497858035395229,
                39.58104773226117
              ],
              [
                -7.515841426841858,
                39.593759959782965
              ],
              [
                -7.548242558889315,
                39.663213326771896
              ],
              [
                -7.5558717532986375,
                39.67720743190085
              ],
              [
                -7.557285934145196,
                39.679801440801945
              ],
              [
                -7.341433474302099,
                39.671843250075035
              ],
              [
                -7.32784257025366,
                39.67478872393505
              ],
              [
                -7.311409459591981,
                39.68031794693991
              ],
              [
                -7.292754277184365,
                39.6833154438391
              ],
              [
                -7.252860068000897,
                39.682333503624605
              ],
              [
                -7.235755172022463,
                39.68651937824993
              ],
              [
                -7.214051070156778,
                39.6761840963692
              ],
              [
                -7.182890179127433,
                39.675098806430604
              ],
              [
                -7.0357673766897975,
                39.689258194496425
              ],
              [
                -7.021142943758815,
                39.69401231463961
              ],
              [
                -7.009619097063508,
                39.71545798529045
              ],
              [
                -7.010704308256125,
                39.72279621477937
              ],
              [
                -7.013649860831336,
                39.72961737872914
              ],
              [
                -7.013339804878165,
                39.73891922345412
              ],
              [
                -7.0087406009171245,
                39.74832427764269
              ],
              [
                -6.996803347544788,
                39.76470578150517
              ],
              [
                -6.993030969477693,
                39.774214300584
              ],
              [
                -6.994581260549492,
                39.782585799123424
              ],
              [
                -6.998870401627447,
                39.79178414940657
              ],
              [
                -7.000265661538674,
                39.802532759621975
              ],
              [
                -6.993030962725319,
                39.816072018325855
              ],
              [
                -6.985227824401478,
                39.821136355970935
              ],
              [
                -6.96233516197149,
                39.82852601656353
              ],
              [
                -6.95282670537204,
                39.832867048931305
              ],
              [
                -6.927660284052266,
                39.86190922268315
              ],
              [
                -6.9242496320953,
                39.87157251645784
              ],
              [
                -6.923474492194248,
                39.88831585502823
              ],
              [
                -6.921769164195586,
                39.897152381987226
              ],
              [
                -6.921562462300947,
                39.90216508481948
              ],
              [
                -6.92512813607773,
                39.91224201195081
              ],
              [
                -6.925231486423023,
                39.917926343087906
              ],
              [
                -6.922285929894889,
                39.922422205573234
              ],
              [
                -6.9125707615303575,
                39.92810663177805
              ],
              [
                -6.9095218554599525,
                39.93198244861235
              ],
              [
                -6.903682417868471,
                39.95668376564619
              ],
              [
                -6.899755008862152,
                39.96562378848076
              ],
              [
                -6.901615359989529,
                39.97647584203199
              ],
              [
                -6.896912797067759,
                39.98712096159603
              ],
              [
                -6.87970454900995,
                40.00918691028743
              ],
              [
                -6.919908813026715,
                40.06489410476053
              ],
              [
                -6.942129680130083,
                40.08633982667728
              ],
              [
                -6.955720581917086,
                40.102927956667365
              ],
              [
                -6.966417603128253,
                40.11031769161177
              ],
              [
                -6.97716630105951,
                40.11341827567173
              ],
              [
                -7.003676310119735,
                40.116312157352276
              ],
              [
                -7.015768594965847,
                40.11905100404982
              ],
              [
                -7.027654174889064,
                40.132641903913054
              ],
              [
                -7.034837199065404,
                40.16674835382059
              ],
              [
                -7.0431054290607715,
                40.1813727846881
              ],
              [
                -7.034578817076552,
                40.19305165812449
              ],
              [
                -7.024760295138953,
                40.21620270185899
              ],
              [
                -7.015768595299596,
                40.22550446432479
              ],
              [
                -6.9977851969786915,
                40.2317056264096
              ],
              [
                -6.9546870530303755,
                40.253358053853646
              ],
              [
                -6.942100808283682,
                40.25497773895542
              ],
              [
                -6.935411742883084,
                40.25583851872129
              ],
              [
                -6.915826374968822,
                40.254443257125246
              ],
              [
                -6.896447713124604,
                40.255476789517026
              ],
              [
                -6.87805090399754,
                40.26524363193482
              ],
              [
                -6.875105347052509,
                40.27123810048634
              ],
              [
                -6.8745090919167255,
                40.27918816464844
              ],
              [
                -6.873865112959224,
                40.28777455485012
              ],
              [
                -6.870196086024303,
                40.29552602268969
              ],
              [
                -6.86394323720177,
                40.300952052710166
              ],
              [
                -6.820793416555188,
                40.32534333878923
              ],
              [
                -6.811956746528838,
                40.332319656054324
              ],
              [
                -6.7944384353544605,
                40.35640084060262
              ],
              [
                -6.828079794584614,
                40.38058544556335
              ],
              [
                -6.851282511176117,
                40.409524235969236
              ],
              [
                -6.85712194871735,
                40.44213205205322
              ],
              [
                -6.838673461511943,
                40.47722034426056
              ],
              [
                -6.815315715223142,
                40.50254181630037
              ],
              [
                -6.812525186776558,
                40.51463408869624
              ],
              [
                -6.818054565666385,
                40.53189404177601
              ],
              [
                -6.828544882344495,
                40.54553661068761
              ],
              [
                -6.8397586671655395,
                40.55457998064557
              ],
              [
                -6.848388630639401,
                40.564760223903754
              ],
              [
                -6.850455689287279,
                40.58222687603867
              ],
              [
                -6.8444612227045045,
                40.59778146573419
              ],
              [
                -6.821310181092314,
                40.63018259958974
              ],
              [
                -6.814282185718743,
                40.64718413511485
              ],
              [
                -6.814230509195873,
                40.65932811049228
              ],
              [
                -6.81624588944171,
                40.67715645837102
              ],
              [
                -6.824307412733098,
                40.710694442629126
              ],
              [
                -6.836968138891843,
                40.7433022771625
              ],
              [
                -6.839138550733681,
                40.757513346402575
              ],
              [
                -6.839138549870768,
                40.77689198541299
              ],
              [
                -6.837278198883527,
                40.786762211544705
              ],
              [
                -6.834539349318397,
                40.792239925627506
              ],
              [
                -6.8335058191886695,
                40.797820948242105
              ],
              [
                -6.83681310913631,
                40.80831123603259
              ],
              [
                -6.83805334356724,
                40.814925829999034
              ],
              [
                -6.836658080771376,
                40.84024728766649
              ],
              [
                -6.820328328447958,
                40.84422639244329
              ],
              [
                -6.816194213220136,
                40.856835407339254
              ],
              [
                -6.82115515288844,
                40.87006462064883
              ],
              [
                -6.832058879313109,
                40.87590406936117
              ],
              [
                -6.8470450427445755,
                40.87890123132088
              ],
              [
                -6.855261597010034,
                40.88722117228055
              ],
              [
                -6.863633177920835,
                40.90830512629961
              ],
              [
                -6.885182250992055,
                40.94892280439585
              ],
              [
                -6.89923824119975,
                40.96675120645814
              ],
              [
                -6.930605835864277,
                40.99207267547592
              ],
              [
                -6.940424358262684,
                41.003389825233064
              ],
              [
                -6.9424914156294255,
                41.0159988570505
              ],
              [
                -6.931794393608907,
                41.029124670510605
              ],
              [
                -6.927866983382929,
                41.04793485927626
              ],
              [
                -6.927447858046629,
                41.0480976123743
              ],
              [
                -6.906834676401715,
                41.05609976292009
              ],
              [
                -6.845288044799535,
                41.051913955503174
              ],
              [
                -6.818002888038942,
                41.05413602153744
              ],
              [
                -6.804360311459831,
                41.06441967068437
              ],
              [
                -6.764776164292154,
                41.108861398091136
              ],
              [
                -6.756507935198232,
                41.12705149949411
              ],
              [
                -6.758988405355728,
                41.15175286550902
              ],
              [
                -6.755216023161052,
                41.15883247678791
              ],
              [
                -6.742245239681262,
                41.17144156788016
              ],
              [
                -6.706950235711408,
                41.19433420096959
              ],
              [
                -6.701265828050608,
                41.20244738156664
              ],
              [
                -6.693772746230881,
                41.21738190343514
              ],
              [
                -6.658219360704874,
                41.25784456371209
              ],
              [
                -6.646643839408494,
                41.267611373441355
              ],
              [
                -6.628918824446723,
                41.26993684154418
              ],
              [
                -6.563496458203449,
                41.27071192406935
              ],
              [
                -6.554453084840669,
                41.275621260863794
              ],
              [
                -6.4958520121860746,
                41.29494825594613
              ],
              [
                -6.463140828620265,
                41.31412016708871
              ],
              [
                -6.430998085786661,
                41.339028183991616
              ],
              [
                -6.399578816449637,
                41.37747546906981
              ],
              [
                -6.395496376117135,
                41.378405605454915
              ],
              [
                -6.383197388872335,
                41.37654533432537
              ],
              [
                -6.379166625451458,
                41.37747546906981
              ],
              [
                -6.376737835373752,
                41.38300493195993
              ],
              [
                -6.375549273604556,
                41.39080793442248
              ],
              [
                -6.376169390693958,
                41.39685407904323
              ],
              [
                -6.379166626203934,
                41.397319239921295
              ],
              [
                -6.36624751577403,
                41.4051739882889
              ],
              [
                -6.352346559662362,
                41.409256539429734
              ],
              [
                -6.321133994230735,
                41.41101355430275
              ],
              [
                -6.321030641405737,
                41.41959181813975
              ],
              [
                -6.282945110435008,
                41.46563552017643
              ],
              [
                -6.28248002205381,
                41.47230176896547
              ],
              [
                -6.285167193404779,
                41.47896795116439
              ],
              [
                -6.285890668154291,
                41.48687455523013
              ],
              [
                -6.279534464008134,
                41.49700307224078
              ],
              [
                -6.253644570511021,
                41.51751857212845
              ],
              [
                -6.205947225372642,
                41.570280264044406
              ],
              [
                -6.216127483701039,
                41.58009882530718
              ],
              [
                -6.230080117944797,
                41.59490404188557
              ],
              [
                -6.272248086790743,
                41.62823533662835
              ],
              [
                -6.317103229190667,
                41.65014612749034
              ],
              [
                -6.365937462299767,
                41.6636079562017
              ],
              [
                -6.447069456660803,
                41.67624273995558
              ],
              [
                -6.460815390925519,
                41.67655286224063
              ],
              [
                -6.467740029393625,
                41.672056941504174
              ],
              [
                -6.474354613583916,
                41.66593328992784
              ],
              [
                -6.488048870946501,
                41.65880203698865
              ],
              [
                -6.503035035101397,
                41.65309176804894
              ],
              [
                -6.513421996728686,
                41.65092131836673
              ],
              [
                -6.541533975981178,
                41.65890530645776
              ],
              [
                -6.555279904875269,
                41.674899131632856
              ],
              [
                -6.560499225725167,
                41.69445868543724
              ],
              [
                -6.563083048403914,
                41.713036380391166
              ],
              [
                -6.567682250808201,
                41.722441502662676
              ],
              [
                -6.57434851343197,
                41.73104570161604
              ],
              [
                -6.577397418897921,
                41.73972724438533
              ],
              [
                -6.571506307241229,
                41.749209906706
              ],
              [
                -6.564374957644099,
                41.757503930284905
              ],
              [
                -6.560137489732425,
                41.76688317690765
              ],
              [
                -6.535746218147544,
                41.848583738800095
              ],
              [
                -6.524222374364159,
                41.86741980590383
              ],
              [
                -6.550060589518097,
                41.87387933514262
              ],
              [
                -6.567888957015704,
                41.875868836437675
              ],
              [
                -6.575795449208634,
                41.882896781487155
              ],
              [
                -6.567630573122096,
                41.92607243811248
              ],
              [
                -6.5716613348769215,
                41.94260891700751
              ],
              [
                -6.585148883451244,
                41.95464948683322
              ],
              [
                -6.609488486823971,
                41.96232355701941
              ],
              [
                -6.6228210013498305,
                41.940955229421725
              ],
              [
                -6.656772421361432,
                41.93307468410831
              ],
              [
                -6.727982542322938,
                41.93085251377498
              ],
              [
                -6.757903197768039,
                41.937570489776306
              ],
              [
                -6.794386760674337,
                41.97971264397897
              ],
              [
                -6.824927532814755,
                41.98376927415724
              ],
              [
                -6.831232057848625,
                41.95395197406336
              ],
              [
                -6.854951537973479,
                41.942944844301486
              ],
              [
                -6.917118283875998,
                41.93909489430227
              ],
              [
                -6.945126913847906,
                41.94335830525903
              ],
              [
                -6.969518185631102,
                41.95769840438935
              ],
              [
                -6.983456184192135,
                41.9629961969405
              ],
              [
                -6.992359168652927,
                41.966380046175026
              ],
              [
                -7.0157685979019515,
                41.95366777999374
              ],
              [
                -7.05127030117455,
                41.94201459632541
              ],
              [
                -7.082741253860612,
                41.95278925262915
              ],
              [
                -7.113178672970498,
                41.97242630019138
              ],
              [
                -7.145373090006409,
                41.98748997984916
              ],
              [
                -7.159739137131694,
                41.98573295962632
              ],
              [
                -7.177309121027603,
                41.97836898922491
              ],
              [
                -7.192605347849649,
                41.969609905406124
              ],
              [
                -7.199943399506663,
                41.9637187585844
              ],
              [
                -7.202113813778114,
                41.94974036494575
              ],
              [
                -7.1956542532973815,
                41.91736494281862
              ],
              [
                -7.197928018568092,
                41.90150033510188
              ],
              [
                -7.209316115096031,
                41.889160799803065
              ],
              [
                -7.218650271014579,
                41.87904698773545
              ],
              [
                -7.251464804727606,
                41.86369907933559
              ],
              [
                -7.32246822295097,
                41.84540562749679
              ],
              [
                -7.340503295924102,
                41.843209329120626
              ],
              [
                -7.376831825351254,
                41.8440360876471
              ],
              [
                -7.391921343929449,
                41.842046560011596
              ],
              [
                -7.40540889768749,
                41.83519955007944
              ],
              [
                -7.429541791660502,
                41.814503138253826
              ],
              [
                -7.442719278862362,
                41.805950619630266
              ],
              [
                -7.446956750005076,
                41.821841199512264
              ],
              [
                -7.456568564768244,
                41.83923028817522
              ],
              [
                -7.46938431844078,
                41.85253691237889
              ],
              [
                -7.483285279980775,
                41.85620597784808
              ],
              [
                -7.493000450987156,
                41.856903658530975
              ],
              [
                -7.508141642913682,
                41.86493926791009
              ],
              [
                -7.515841433164823,
                41.86499099938959
              ],
              [
                -7.523282837415547,
                41.860159211049016
              ],
              [
                -7.525246538433579,
                41.854164671949626
              ],
              [
                -7.526331744711136,
                41.84736922765488
              ],
              [
                -7.531551063912471,
                41.84016034637329
              ],
              [
                -7.546692258444946,
                41.832047159349365
              ],
              [
                -7.567104454150771,
                41.826595409770626
              ],
              [
                -7.5883951412174495,
                41.82421822321929
              ],
              [
                -7.606068480624363,
                41.82553598200823
              ],
              [
                -7.622191528769688,
                41.83233143650138
              ],
              [
                -7.62281164234919,
                41.84173648870056
              ],
              [
                -7.607360390703037,
                41.87318163100288
              ],
              [
                -7.661155555825696,
                41.87491277040113
              ],
              [
                -7.678673871866241,
                41.88134660485332
              ],
              [
                -7.706372438760101,
                41.8962552294955
              ],
              [
                -7.722030393448714,
                41.89925236098663
              ],
              [
                -7.750142372549804,
                41.88837447454998
              ],
              [
                -7.81215409026811,
                41.877134845426504
              ],
              [
                -7.839232547265509,
                41.87837521872911
              ],
              [
                -7.849722861725274,
                41.87576552296238
              ],
              [
                -7.854425411988761,
                41.87026187328586
              ],
              [
                -7.857887738139063,
                41.863776600513816
              ],
              [
                -7.864812379858382,
                41.857885479988774
              ],
              [
                -7.896593381657847,
                41.85793705904269
              ],
              [
                -7.903362997785987,
                41.886824281069664
              ],
              [
                -7.906101843997151,
                41.91385094504446
              ],
              [
                -7.925790569394865,
                41.9081666379605
              ],
              [
                -7.930493125271594,
                41.8966686520396
              ],
              [
                -7.935350710382967,
                41.8799513285901
              ],
              [
                -7.944755820033316,
                41.866954675656814
              ],
              [
                -7.96335933693051,
                41.866618799091256
              ],
              [
                -7.979430703892557,
                41.868608271762746
              ],
              [
                -7.993641721354594,
                41.863673137808945
              ],
              [
                -8.005889039095578,
                41.8539580539019
              ],
              [
                -8.015707558504618,
                41.84189152433231
              ],
              [
                -8.04857377075052,
                41.816389256354725
              ],
              [
                -8.050445713824633,
                41.815986366134204
              ],
              [
                -8.093480589868527,
                41.80672574352132
              ],
              [
                -8.17957352603909,
                41.81070483259329
              ],
              [
                -8.179265098822215,
                41.81261247648163
              ],
              [
                -8.175387734013242,
                41.836594702755384
              ],
              [
                -8.177041378737268,
                41.849849679390374
              ],
              [
                -8.184586142414936,
                41.85773043945248
              ],
              [
                -8.220397908377365,
                41.86819487222844
              ],
              [
                -8.23171504534602,
                41.886049034406135
              ],
              [
                -8.230216433237414,
                41.90467849637666
              ],
              [
                -8.220707970200259,
                41.92271359165752
              ],
              [
                -8.182131510829713,
                41.96542411137932
              ],
              [
                -8.152960160834475,
                41.9868180656946
              ],
              [
                -8.123918007226122,
                42.00089992448261
              ],
              [
                -8.108027506761475,
                42.01089934768056
              ],
              [
                -8.097356322895264,
                42.023482562662515
              ],
              [
                -8.095082562024253,
                42.04092340619648
              ],
              [
                -8.103195759066464,
                42.05580612989802
              ],
              [
                -8.118440307715337,
                42.066864922669176
              ],
              [
                -8.1376122621254,
                42.07291103041453
              ],
              [
                -8.15838619249383,
                42.07138667218905
              ],
              [
                -8.176162886197536,
                42.06526303062232
              ],
              [
                -8.19130407932749,
                42.06208491031903
              ],
              [
                -8.204016480104215,
                42.069552106295355
              ],
              [
                -8.2073754508739,
                42.08577856718816
              ],
              [
                -8.204326534588182,
                42.128799058072985
              ],
              [
                -8.213395754889659,
                42.1440179063606
              ],
              [
                -8.22236161268734,
                42.153629653156266
              ],
              [
                -8.252333946058492,
                42.13758417293201
              ],
              [
                -8.27067907860423,
                42.13200310694661
              ],
              [
                -8.287835654618135,
                42.131434667178
              ],
              [
                -8.29538041256516,
                42.13009105727604
              ],
              [
                -8.304268756921296,
                42.125827715595626
              ],
              [
                -8.329951947712663,
                42.1084386777188
              ],
              [
                -8.346746787240159,
                42.101694871798685
              ],
              [
                -8.50120764037992,
                42.08309129561073
              ],
              [
                -8.520017861486817,
                42.07771694794501
              ],
              [
                -8.554434366889941,
                42.060069475677615
              ],
              [
                -8.572805341093026,
                42.054410974178815
              ],
              [
                -8.609418089566923,
                42.05366157092971
              ],
              [
                -8.626884723531568,
                42.05102607224895
              ],
              [
                -8.643886269135432,
                42.04149174210698
              ],
              [
                -8.652567910990106,
                42.031440714900064
              ],
              [
                -8.663213260352089,
                42.00989173301206
              ],
              [
                -8.670809693428025,
                41.999814787812255
              ],
              [
                -8.691273556378803,
                41.98960860939469
              ],
              [
                -8.717008425317847,
                41.98376927415724
              ],
              [
                -8.739591024271812,
                41.97511342963568
              ],
              [
                -8.750803188423173,
                41.968980198057025
              ],
              [
                -8.761952279975974,
                41.95258213888935
              ],
              [
                -8.777088994756921,
                41.937160523309814
              ],
              [
                -8.795399545819578,
                41.92568599817963
              ],
              [
                -8.815988735747574,
                41.921210022804004
              ],
              [
                -8.832834437663553,
                41.91396716253069
              ],
              [
                -8.848784957052706,
                41.899481451498005
              ],
              [
                -8.864654103198204,
                41.88890213006381
              ],
              [
                -8.881255664668332,
                41.893296651132175
              ],
              [
                -8.878732880024781,
                41.907131313868724
              ],
              [
                -8.898589651540975,
                42.10175209176732
              ],
              [
                -8.895497197241783,
                42.119085949114776
              ],
              [
                -8.884592251830696,
                42.12604400856735
              ],
              [
                -8.844960089136261,
                42.126613656405304
              ],
              [
                -8.826527469492333,
                42.13051985240198
              ],
              [
                -8.819081184145011,
                42.13971588996343
              ],
              [
                -8.823719854074731,
                42.147609728713604
              ],
              [
                -8.842762824428048,
                42.15444569335821
              ],
              [
                -8.846994597771632,
                42.160834108386034
              ],
              [
                -8.842030406251055,
                42.1642927761694
              ],
              [
                -8.815988734319909,
                42.174505892717875
              ],
              [
                -8.813465946871816,
                42.17869694316047
              ],
              [
                -8.811024541003167,
                42.18813707025138
              ],
              [
                -8.805775521159164,
                42.19749585866339
              ],
              [
                -8.795236784567622,
                42.20172763803478
              ],
              [
                -8.790638798983315,
                42.204535181773565
              ],
              [
                -8.77196203932235,
                42.222235343704014
              ],
              [
                -8.719553186802582,
                42.252346050786166
              ],
              [
                -8.706450975351665,
                42.256415092642904
              ],
              [
                -8.701893680936948,
                42.258530928860665
              ],
              [
                -8.669911260965032,
                42.28091052760479
              ],
              [
                -8.652007615561782,
                42.28632232392455
              ],
              [
                -8.631743945229545,
                42.29682040551991
              ],
              [
                -8.62515215010399,
                42.301947376694514
              ],
              [
                -8.621652802298723,
                42.31020749251359
              ],
              [
                -8.621652798517564,
                42.34080637199148
              ],
              [
                -8.6227107391236,
                42.34747952008317
              ],
              [
                -8.626454228465311,
                42.348333999454425
              ],
              [
                -8.634755008889579,
                42.346380862576446
              ],
              [
                -8.649891731277647,
                42.33559805474473
              ],
              [
                -8.660755992198663,
                42.31679928712096
              ],
              [
                -8.674794075269778,
                42.29901765057286
              ],
              [
                -8.699574349819041,
                42.291164492467246
              ],
              [
                -8.719838021853388,
                42.28758376409057
              ],
              [
                -8.773915167070653,
                42.26898832900834
              ],
              [
                -8.78498287986469,
                42.26007727449163
              ],
              [
                -8.795765751215804,
                42.258246104220284
              ],
              [
                -8.848296681149057,
                42.2609724415651
              ],
              [
                -8.867502407339693,
                42.256415092642904
              ],
              [
                -8.863636847061176,
                42.26898832900834
              ],
              [
                -8.853423633656833,
                42.29108310853357
              ],
              [
                -8.853260868306297,
                42.304836275508926
              ],
              [
                -8.84699459230824,
                42.304836275508926
              ],
              [
                -8.832997197446883,
                42.28912989820724
              ],
              [
                -8.82721920594628,
                42.29669832820584
              ],
              [
                -8.826527476044788,
                42.32904700373274
              ],
              [
                -8.828521284468621,
                42.33722558144037
              ],
              [
                -8.830718551995512,
                42.34162014339793
              ],
              [
                -8.827259896948249,
                42.34414301047777
              ],
              [
                -8.812855594825452,
                42.346380862576446
              ],
              [
                -8.776926238218634,
                42.34015538622008
              ],
              [
                -8.771962041681302,
                42.34271879011185
              ],
              [
                -8.764637824722326,
                42.35569895433746
              ],
              [
                -8.726877410184942,
                42.388739369716504
              ],
              [
                -8.709828255157102,
                42.40037671871879
              ],
              [
                -8.676869267272242,
                42.416449229906554
              ],
              [
                -8.66250566559637,
                42.426906696464336
              ],
              [
                -8.65526282366505,
                42.44135160250347
              ],
              [
                -8.664377407812085,
                42.437974347133824
              ],
              [
                -8.672515429047628,
                42.43842194298072
              ],
              [
                -8.682525192660872,
                42.44135160250347
              ],
              [
                -8.691273567775978,
                42.44061922391973
              ],
              [
                -8.694488083762412,
                42.43964261962211
              ],
              [
                -8.69676673081134,
                42.437974347133824
              ],
              [
                -8.71882076430977,
                42.42796452996509
              ],
              [
                -8.743641732875966,
                42.41323480628941
              ],
              [
                -8.757639124683418,
                42.40721258478703
              ],
              [
                -8.779367639826077,
                42.40289943679781
              ],
              [
                -8.8110245410306,
                42.400702176098186
              ],
              [
                -8.84357662847233,
                42.40371331272046
              ],
              [
                -8.867502409098277,
                42.41469963310219
              ],
              [
                -8.875721811652422,
                42.42597082330849
              ],
              [
                -8.880238407266095,
                42.44501366404468
              ],
              [
                -8.888010217982298,
                42.45563381554594
              ],
              [
                -8.90094967084715,
                42.46100488688922
              ],
              [
                -8.935454883632906,
                42.46539951355709
              ],
              [
                -8.942616338269007,
                42.46930569652254
              ],
              [
                -8.935047981657204,
                42.479071369099515
              ],
              [
                -8.916737434450557,
                42.48761628699699
              ],
              [
                -8.895985481087802,
                42.49388255575845
              ],
              [
                -8.881255665261861,
                42.496568146325856
              ],
              [
                -8.86900793831943,
                42.49339419913836
              ],
              [
                -8.860829233600866,
                42.48501216325928
              ],
              [
                -8.861154753123792,
                42.47557202958678
              ],
              [
                -8.874338343282263,
                42.46930569652254
              ],
              [
                -8.865549284780931,
                42.465033305788275
              ],
              [
                -8.851551886612972,
                42.460760801211215
              ],
              [
                -8.83698483138173,
                42.45892978286187
              ],
              [
                -8.826527471690785,
                42.46185941557386
              ],
              [
                -8.822499154252498,
                42.472357514287175
              ],
              [
                -8.825184697822472,
                42.48411688507231
              ],
              [
                -8.825062630978147,
                42.49494053689498
              ],
              [
                -8.81285559620489,
                42.502752960757896
              ],
              [
                -8.825184697104838,
                42.537420907695335
              ],
              [
                -8.826527478935573,
                42.55463299945523
              ],
              [
                -8.822987437618432,
                42.56952553081754
              ],
              [
                -8.813832164629229,
                42.58144773108236
              ],
              [
                -8.801584442702353,
                42.5893009226396
              ],
              [
                -8.788400839082035,
                42.592189726528176
              ],
              [
                -8.775502080207408,
                42.60472236177327
              ],
              [
                -8.7387589189606,
                42.66608309445918
              ],
              [
                -8.730946413629212,
                42.6884218534522
              ],
              [
                -8.73717199962612,
                42.6884218534522
              ],
              [
                -8.744048624659248,
                42.672430582430856
              ],
              [
                -8.75389564134395,
                42.65688719886375
              ],
              [
                -8.767323364524199,
                42.645168230172786
              ],
              [
                -8.78498287360876,
                42.64057031161655
              ],
              [
                -8.803822388453403,
                42.645941341293586
              ],
              [
                -8.815988730380496,
                42.658514603145825
              ],
              [
                -8.826242645853046,
                42.674139793253055
              ],
              [
                -8.839507609813564,
                42.682440373184086
              ],
              [
                -8.854603642307286,
                42.66156641916505
              ],
              [
                -8.857004358055624,
                42.64911524312619
              ],
              [
                -8.84699459158483,
                42.64057031161655
              ],
              [
                -8.868763798358609,
                42.61749903820211
              ],
              [
                -8.880523246109098,
                42.611802578010995
              ],
              [
                -8.894846159086441,
                42.62010327865259
              ],
              [
                -8.889475059656522,
                42.63060121741679
              ],
              [
                -8.903431771450752,
                42.62547437988029
              ],
              [
                -8.936390751273409,
                42.60643132789239
              ],
              [
                -8.92223059716392,
                42.59369536337626
              ],
              [
                -8.933990035303204,
                42.58681869843607
              ],
              [
                -8.969878715942519,
                42.57916912959157
              ],
              [
                -8.972767712231962,
                42.5739200925148
              ],
              [
                -8.980783654319712,
                42.551214838199066
              ],
              [
                -8.989165823691819,
                42.54889566773336
              ],
              [
                -8.997059698476773,
                42.54340238091694
              ],
              [
                -9.011545379384872,
                42.53070714504764
              ],
              [
                -9.02635658068076,
                42.54311769183809
              ],
              [
                -9.02855383852034,
                42.56146878789614
              ],
              [
                -9.033355275214616,
                42.578111113517636
              ],
              [
                -9.055816205873706,
                42.58539451714147
              ],
              [
                -9.070871555122165,
                42.59613690573245
              ],
              [
                -9.065744588152166,
                42.6203065741047
              ],
              [
                -9.051421672269278,
                42.645941341293586
              ],
              [
                -9.038807738350757,
                42.66107804218258
              ],
              [
                -9.039458791136454,
                42.6730411444049
              ],
              [
                -9.036284964678178,
                42.68793375257722
              ],
              [
                -9.030140747738066,
                42.707708929415304
              ],
              [
                -9.018788221911674,
                42.71975345742666
              ],
              [
                -9.014027466429342,
                42.726833272218364
              ],
              [
                -9.006255659958345,
                42.73383203834737
              ],
              [
                -8.994496222884608,
                42.737005924735364
              ],
              [
                -8.992014122288428,
                42.73908102946482
              ],
              [
                -8.963124148854948,
                42.75128807136057
              ],
              [
                -8.937367320179145,
                42.77777747374726
              ],
              [
                -8.922230595645948,
                42.78811265047581
              ],
              [
                -8.898264125740779,
                42.79230375305009
              ],
              [
                -8.891346801506604,
                42.79934301743937
              ],
              [
                -8.88491776873059,
                42.81500877133645
              ],
              [
                -8.887684706167017,
                42.831122259199724
              ],
              [
                -8.908436653775084,
                42.83946362432025
              ],
              [
                -8.91258703861474,
                42.81659568331334
              ],
              [
                -8.928089975542335,
                42.802517044192676
              ],
              [
                -8.951039193302975,
                42.795111420664846
              ],
              [
                -8.97736568772959,
                42.79230375305009
              ],
              [
                -9.028187631453314,
                42.79787836990498
              ],
              [
                -9.048939578185028,
                42.79474510967309
              ],
              [
                -9.045643684966468,
                42.77802157084819
              ],
              [
                -9.068674282438558,
                42.759710994074354
              ],
              [
                -9.081288207766134,
                42.75482805139211
              ],
              [
                -9.100249796976358,
                42.757513602773905
              ],
              [
                -9.113433391281648,
                42.766058530918
              ],
              [
                -9.120106582781922,
                42.77899826450845
              ],
              [
                -9.125477662339271,
                42.794989215638125
              ],
              [
                -9.13499915768773,
                42.81277099142377
              ],
              [
                -9.122547976093395,
                42.81260804522825
              ],
              [
                -9.113189253691754,
                42.816351566042684
              ],
              [
                -9.1061905632077,
                42.82330971839501
              ],
              [
                -9.100249800773042,
                42.833278650557766
              ],
              [
                -9.10838783024897,
                42.844834804446435
              ],
              [
                -9.122222460755925,
                42.85175203458556
              ],
              [
                -9.141224740934183,
                42.85744867223388
              ],
              [
                -9.142323375917403,
                42.865301919626795
              ],
              [
                -9.147531702558863,
                42.87860744207205
              ],
              [
                -9.148671023240821,
                42.88446677253768
              ],
              [
                -9.146636529383391,
                42.88837323669324
              ],
              [
                -9.137521932766466,
                42.89606342409768
              ],
              [
                -9.134999157083495,
                42.90216713755598
              ],
              [
                -9.133697071963544,
                42.91120031900377
              ],
              [
                -9.13451086451744,
                42.91754779434739
              ],
              [
                -9.141428189444191,
                42.92141348753498
              ],
              [
                -9.158599405981706,
                42.92263404742077
              ],
              [
                -9.167876751018046,
                42.926825147423756
              ],
              [
                -9.183461066159943,
                42.945257863946935
              ],
              [
                -9.195871550764275,
                42.9493269236684
              ],
              [
                -9.195871549501229,
                42.94314200356778
              ],
              [
                -9.190012176717367,
                42.93239985891527
              ],
              [
                -9.195790160153134,
                42.9265809721588
              ],
              [
                -9.205189584668085,
                42.924750117901254
              ],
              [
                -9.210072388799974,
                42.92572651178681
              ],
              [
                -9.214344853729592,
                42.93903225074965
              ],
              [
                -9.224232556598475,
                42.940212413536116
              ],
              [
                -9.235585083910443,
                42.93488178724589
              ],
              [
                -9.244252074793101,
                42.9287782501094
              ],
              [
                -9.251698366089638,
                42.92023337278294
              ],
              [
                -9.261708129356856,
                42.900173098973404
              ],
              [
                -9.268422004019152,
                42.89130280236433
              ],
              [
                -9.273060672587421,
                42.89333724231365
              ],
              [
                -9.282948377204523,
                42.91661216340503
              ],
              [
                -9.29198156787947,
                42.92263404742077
              ],
              [
                -9.291981567755851,
                42.9287782501094
              ],
              [
                -9.285389772263837,
                42.93834045355968
              ],
              [
                -9.264759895123488,
                42.98033275133804
              ],
              [
                -9.263986778647325,
                42.98651756264112
              ],
              [
                -9.26183020292357,
                42.994492828868395
              ],
              [
                -9.258656375882653,
                43.002386727009274
              ],
              [
                -9.254790812161472,
                43.00800189055816
              ],
              [
                -9.250965950852008,
                43.016791099131524
              ],
              [
                -9.257313604187013,
                43.02326077470925
              ],
              [
                -9.272124807546884,
                43.03127682696748
              ],
              [
                -9.27953040632919,
                43.05499915376422
              ],
              [
                -9.271107557771394,
                43.060492382752074
              ],
              [
                -9.257923951635716,
                43.06089905465412
              ],
              [
                -9.251088019074604,
                43.069769580509366
              ],
              [
                -9.245716925658007,
                43.08799875853647
              ],
              [
                -9.233957483844616,
                43.096502956215794
              ],
              [
                -9.222320115762034,
                43.10272857849354
              ],
              [
                -9.217600059722827,
                43.11444725196451
              ],
              [
                -9.202951619191348,
                43.105047770780786
              ],
              [
                -9.189808716851415,
                43.1023215651154
              ],
              [
                -9.176828573681739,
                43.105576769731066
              ],
              [
                -9.16226151874848,
                43.11444725196451
              ],
              [
                -9.156890430476146,
                43.11973707414999
              ],
              [
                -9.154204877261769,
                43.12470114863444
              ],
              [
                -9.150298632016272,
                43.12958405231178
              ],
              [
                -9.141224738023624,
                43.134873746358906
              ],
              [
                -9.133127403262554,
                43.13796612247495
              ],
              [
                -9.12580318274085,
                43.13959369730675
              ],
              [
                -9.107736783517137,
                43.14114005090942
              ],
              [
                -9.107736785666226,
                43.14850500107565
              ],
              [
                -9.124663873630361,
                43.1425236509233
              ],
              [
                -9.147084116491532,
                43.13869868253737
              ],
              [
                -9.16331945854723,
                43.139756455110664
              ],
              [
                -9.162261525682167,
                43.14850500107565
              ],
              [
                -9.194203254860476,
                43.13654207533511
              ],
              [
                -9.208363414323811,
                43.13788489599594
              ],
              [
                -9.217600070671997,
                43.15534101326276
              ],
              [
                -9.170074018786218,
                43.188747382921925
              ],
              [
                -9.137928835223367,
                43.201524064939086
              ],
              [
                -9.10041255960177,
                43.18952049077815
              ],
              [
                -9.083159964718211,
                43.189764806522575
              ],
              [
                -9.065174931926474,
                43.19232815214409
              ],
              [
                -9.052398241071113,
                43.19635651337007
              ],
              [
                -9.039784315758956,
                43.2045353532436
              ],
              [
                -9.026966932097624,
                43.21015057564767
              ],
              [
                -9.016753703860008,
                43.22386290444889
              ],
              [
                -9.011545380714672,
                43.23875567273643
              ],
              [
                -9.004058401711568,
                43.23875567273643
              ],
              [
                -8.985747848235828,
                43.22687403745055
              ],
              [
                -8.958973760926645,
                43.22748442114559
              ],
              [
                -8.93252518967291,
                43.23529685769201
              ],
              [
                -8.915272590914496,
                43.245021894849444
              ],
              [
                -8.93639074842944,
                43.24408589653755
              ],
              [
                -8.94815019250958,
                43.24994535102443
              ],
              [
                -8.963124148307607,
                43.27228415598091
              ],
              [
                -8.967518690357013,
                43.27195884925284
              ],
              [
                -8.979807087276836,
                43.27692276948815
              ],
              [
                -8.98802649472815,
                43.283026409406574
              ],
              [
                -8.980783655647443,
                43.285956076474214
              ],
              [
                -8.970855276474087,
                43.28656654030548
              ],
              [
                -8.930490692983561,
                43.299750144495626
              ],
              [
                -8.888010223644782,
                43.3207462322028
              ],
              [
                -8.856597458520358,
                43.32689033799845
              ],
              [
                -8.849110488583742,
                43.334051973749325
              ],
              [
                -8.841175914723916,
                43.33893471009807
              ],
              [
                -8.829986138960864,
                43.34121341980076
              ],
              [
                -8.817005988102533,
                43.33584217233507
              ],
              [
                -8.785552537552405,
                43.31244537115348
              ],
              [
                -8.768544068866296,
                43.30707416449989
              ],
              [
                -8.750477665758474,
                43.30491766550524
              ],
              [
                -8.711740687565992,
                43.295558957400566
              ],
              [
                -8.693104626141459,
                43.293402513771014
              ],
              [
                -8.665394654862832,
                43.301174097963596
              ],
              [
                -8.63003496208411,
                43.31586338993784
              ],
              [
                -8.59251868262309,
                43.32420479218111
              ],
              [
                -8.558420371830335,
                43.31321838709915
              ],
              [
                -8.505970825563884,
                43.33152890766149
              ],
              [
                -8.497547975732633,
                43.3377952074244
              ],
              [
                -8.49425208908252,
                43.346625211671416
              ],
              [
                -8.486073373163409,
                43.35431554122567
              ],
              [
                -8.475982231638373,
                43.35968670638016
              ],
              [
                -8.455718548309193,
                43.36334858328254
              ],
              [
                -8.451405399905797,
                43.367376956514065
              ],
              [
                -8.448963988865643,
                43.37197485559273
              ],
              [
                -8.44302323420716,
                43.37531145151551
              ],
              [
                -8.388295045113374,
                43.38589089637
              ],
              [
                -8.384673635300008,
                43.3727074922411
              ],
              [
                -8.375721805893475,
                43.36298242467751
              ],
              [
                -8.353586386796305,
                43.34861877392443
              ],
              [
                -8.340809703812488,
                43.359930810281156
              ],
              [
                -8.337269657113012,
                43.36904523415872
              ],
              [
                -8.339914512743444,
                43.39272686655695
              ],
              [
                -8.33071855504616,
                43.40566642975538
              ],
              [
                -8.310617639381775,
                43.403143567422305
              ],
              [
                -8.281564906070741,
                43.389593776628544
              ],
              [
                -8.267201299864565,
                43.38593168419696
              ],
              [
                -8.260812953610975,
                43.37702054585072
              ],
              [
                -8.257069458482986,
                43.36566789913011
              ],
              [
                -8.250559041908174,
                43.35488500889583
              ],
              [
                -8.227528451482778,
                43.33812086627891
              ],
              [
                -8.21727453626525,
                43.32831437772703
              ],
              [
                -8.210194460040642,
                43.31321838709915
              ],
              [
                -8.202463338115104,
                43.32925024729545
              ],
              [
                -8.20295162187772,
                43.34467183365021
              ],
              [
                -8.210194458394465,
                43.37531145151551
              ],
              [
                -8.209624797789942,
                43.39069231891199
              ],
              [
                -8.204823377659743,
                43.399725793631745
              ],
              [
                -8.193959117332286,
                43.40680580144719
              ],
              [
                -8.17540442826572,
                43.41632726399583
              ],
              [
                -8.195057752746536,
                43.42324467554394
              ],
              [
                -8.213286919240584,
                43.42495364955508
              ],
              [
                -8.247141081999793,
                43.42308181498644
              ],
              [
                -8.264759891426811,
                43.42731346915115
              ],
              [
                -8.288726368232856,
                43.446234488615765
              ],
              [
                -8.305165162176205,
                43.451076443677366
              ],
              [
                -8.286488415945156,
                43.461981615223706
              ],
              [
                -8.185617644230538,
                43.471503044121775
              ],
              [
                -8.178781711168043,
                43.47329349140542
              ],
              [
                -8.171457492549136,
                43.47797286156927
              ],
              [
                -8.166981576672367,
                43.48456455539952
              ],
              [
                -8.168568481967688,
                43.49201066021284
              ],
              [
                -8.173451299085952,
                43.49274319052913
              ],
              [
                -8.196522595451054,
                43.485174986961866
              ],
              [
                -8.257313611244804,
                43.4777286928196
              ],
              [
                -8.253651492274917,
                43.4812685439773
              ],
              [
                -8.250884574725529,
                43.48285565596175
              ],
              [
                -8.24372311648248,
                43.485174986961866
              ],
              [
                -8.247547973929178,
                43.487738199814466
              ],
              [
                -8.257313598891262,
                43.49201066021284
              ],
              [
                -8.269195113487218,
                43.478949233465116
              ],
              [
                -8.288970501850685,
                43.472967733581285
              ],
              [
                -8.333119272270721,
                43.471503044121775
              ],
              [
                -8.325347461084226,
                43.48676180851245
              ],
              [
                -8.321685352764648,
                43.50787998663536
              ],
              [
                -8.31663977790829,
                43.5228945960976
              ],
              [
                -8.305165160895022,
                43.519354411254945
              ],
              [
                -8.292103643136182,
                43.532945015196276
              ],
              [
                -8.300160293007467,
                43.538234913736034
              ],
              [
                -8.308216922503805,
                43.54633202537659
              ],
              [
                -8.313221809360394,
                43.55634187148169
              ],
              [
                -8.312652150549312,
                43.567124794900145
              ],
              [
                -8.30870520954812,
                43.567124794900145
              ],
              [
                -8.291330535185493,
                43.56484614146966
              ],
              [
                -8.284657358540713,
                43.567124794900145
              ],
              [
                -8.26097571717964,
                43.56452062051568
              ],
              [
                -8.232248499834311,
                43.57550685763384
              ],
              [
                -8.086659313611365,
                43.656480308135954
              ],
              [
                -8.082997193559152,
                43.64545305483411
              ],
              [
                -8.074615031176391,
                43.63963436150958
              ],
              [
                -8.063547329492305,
                43.63886138416112
              ],
              [
                -8.05186926426153,
                43.64280821231097
              ],
              [
                -8.062408004300282,
                43.642319996355326
              ],
              [
                -8.065541139251787,
                43.64280821231097
              ],
              [
                -8.065541147451569,
                43.649074663319475
              ],
              [
                -8.06126867858987,
                43.65094624049047
              ],
              [
                -8.056467254429101,
                43.654242306891405
              ],
              [
                -8.051869274591555,
                43.656480308135954
              ],
              [
                -8.071156374208345,
                43.66787333786437
              ],
              [
                -8.073963990418244,
                43.67853412809707
              ],
              [
                -8.069162567402563,
                43.689276506507206
              ],
              [
                -8.065541151882691,
                43.70087326068914
              ],
              [
                -8.05931556268986,
                43.70941811468608
              ],
              [
                -8.044504360414019,
                43.71210357048314
              ],
              [
                -8.010975717534524,
                43.711737426372146
              ],
              [
                -7.981190563572277,
                43.71784098543663
              ],
              [
                -7.952951631270037,
                43.730129391227
              ],
              [
                -7.928130669311636,
                43.74677168869222
              ],
              [
                -7.908558724595693,
                43.766343526627786
              ],
              [
                -7.880848761312764,
                43.76325102903535
              ],
              [
                -7.869048638096845,
                43.748846880025035
              ],
              [
                -7.861480278206794,
                43.73118735576536
              ],
              [
                -7.846506308249504,
                43.71796283207638
              ],
              [
                -7.846506316482527,
                43.711737426372146
              ],
              [
                -7.852284314603551,
                43.714178900630266
              ],
              [
                -7.862294073310411,
                43.71625393607601
              ],
              [
                -7.86758378223404,
                43.71796283207638
              ],
              [
                -7.874623179605329,
                43.70941811468608
              ],
              [
                -7.879261844261183,
                43.70050682143288
              ],
              [
                -7.8797908124430425,
                43.691961837929384
              ],
              [
                -7.873768678096192,
                43.6844748730585
              ],
              [
                -7.8841039760032885,
                43.678615757964856
              ],
              [
                -7.887318490245001,
                43.67967359714972
              ],
              [
                -7.8948868420803855,
                43.6844748730585
              ],
              [
                -7.901234502743067,
                43.67975492264113
              ],
              [
                -7.903879363130009,
                43.67829015235214
              ],
              [
                -7.90855872364011,
                43.676988036922936
              ],
              [
                -7.908558729353045,
                43.67015222319636
              ],
              [
                -7.85838782388967,
                43.66819893569412
              ],
              [
                -7.849232552900725,
                43.67560460065365
              ],
              [
                -7.867583781390739,
                43.69745500058452
              ],
              [
                -7.856027795594487,
                43.70343651649019
              ],
              [
                -7.843861450228184,
                43.703802653608584
              ],
              [
                -7.8191625574314365,
                43.69745500058452
              ],
              [
                -7.821400523195697,
                43.70075111423607
              ],
              [
                -7.823964001963985,
                43.70807539301052
              ],
              [
                -7.826039194476038,
                43.711737426372146
              ],
              [
                -7.812001103910317,
                43.72308986504583
              ],
              [
                -7.7938533200958835,
                43.73411695315151
              ],
              [
                -7.773793099986814,
                43.74258051488848
              ],
              [
                -7.734038871294482,
                43.7500675675317
              ],
              [
                -7.712757935386028,
                43.760687419814374
              ],
              [
                -7.695708789711115,
                43.77488845215152
              ],
              [
                -7.68883216149834,
                43.7899844531179
              ],
              [
                -7.6855362597208146,
                43.79344305014282
              ],
              [
                -7.6783341190173156,
                43.790472835074155
              ],
              [
                -7.6712947192485546,
                43.782863523026506
              ],
              [
                -7.668324343373005,
                43.77252828346635
              ],
              [
                -7.672596803707903,
                43.766668893633145
              ],
              [
                -7.695627413562581,
                43.74591718311201
              ],
              [
                -7.696156376059405,
                43.73151269637237
              ],
              [
                -7.691558399506214,
                43.72724033564147
              ],
              [
                -7.683990043629485,
                43.72870527084957
              ],
              [
                -7.6751602868255215,
                43.73163485147599
              ],
              [
                -7.673573366095676,
                43.734360960231655
              ],
              [
                -7.6741430267311594,
                43.73920305171735
              ],
              [
                -7.672474745336234,
                43.74384200580774
              ],
              [
                -7.66462155454017,
                43.74591718311201
              ],
              [
                -7.658029750170883,
                43.746527369990666
              ],
              [
                -7.641021288629149,
                43.75267163113688
              ],
              [
                -7.637603322429482,
                43.73908119911369
              ],
              [
                -7.613026489597437,
                43.70429093844847
              ],
              [
                -7.615956181361632,
                43.68854395243365
              ],
              [
                -7.607167118840339,
                43.69110744018851
              ],
              [
                -7.594593882531988,
                43.70368081093928
              ],
              [
                -7.586415162440082,
                43.71796283207638
              ],
              [
                -7.57428951954761,
                43.71454504679878
              ],
              [
                -7.565419069477033,
                43.719793886572155
              ],
              [
                -7.555775519156488,
                43.72760649282404
              ],
              [
                -7.541411913811133,
                43.73163485147599
              ],
              [
                -7.502023886502261,
                43.728338808116014
              ],
              [
                -7.490142384123676,
                43.725327915709514
              ],
              [
                -7.407622852074148,
                43.69122958393392
              ],
              [
                -7.367054819499289,
                43.68008052934876
              ],
              [
                -7.304107230684626,
                43.598578302540226
              ],
              [
                -7.256743940673568,
                43.58161033996401
              ],
              [
                -7.260161918192382,
                43.57750084133011
              ],
              [
                -7.262277792664122,
                43.574286049544014
              ],
              [
                -7.265126111833792,
                43.57147872149232
              ],
              [
                -7.271066862104152,
                43.56863030219354
              ],
              [
                -7.271066861875874,
                43.56114331678249
              ],
              [
                -7.257720507057932,
                43.55666738637888
              ],
              [
                -7.2496231759649525,
                43.559393621167416
              ],
              [
                -7.242014124109254,
                43.564805337146026
              ],
              [
                -7.230091927097921,
                43.56863030219354
              ],
              [
                -7.215443494893067,
                43.56867110687243
              ],
              [
                -7.194894983201222,
                43.56350325489773
              ],
              [
                -7.156971807433168,
                43.55927151423252
              ],
              [
                -7.0958552676278615,
                43.56098040539303
              ],
              [
                -7.0793350910749995,
                43.56863030219354
              ],
              [
                -7.061594207283227,
                43.561590942780214
              ],
              [
                -7.044300910965938,
                43.559393621167416
              ],
              [
                -7.032338014021282,
                43.553005129302036
              ],
              [
                -7.030873181330117,
                43.5332300158813
              ],
              [
                -7.037749806424003,
                43.522243616481695
              ],
              [
                -7.048410607093274,
                43.51044333125368
              ],
              [
                -7.05361894113941,
                43.496527340919215
              ],
              [
                -7.044585740017474,
                43.4791934028885
              ],
              [
                -7.043853318017576,
                43.4791934028885
              ],
              [
                -7.038319464018326,
                43.4791934028885
              ],
              [
                -7.032704225562516,
                43.49546933438791
              ],
              [
                -7.029530400005967,
                43.51215233742962
              ],
              [
                -7.023752409413396,
                43.52582432074882
              ],
              [
                -7.010365369314565,
                43.5332300158813
              ],
              [
                -7.001372851055879,
                43.55666738637888
              ],
              [
                -6.943959109791233,
                43.5659853144524
              ],
              [
                -6.845936654039548,
                43.56863030219354
              ],
              [
                -6.830718551279914,
                43.565130858310965
              ],
              [
                -6.770822721028187,
                43.56863030219354
              ],
              [
                -6.7296443392585985,
                43.55975994217555
              ],
              [
                -6.70372474143673,
                43.55756262971501
              ],
              [
                -6.648671025814455,
                43.579046885319656
              ],
              [
                -6.597727019374517,
                43.57522213406668
              ],
              [
                -6.546620250932203,
                43.56183515797253
              ],
              [
                -6.510121224278481,
                43.54747145489293
              ],
              [
                -6.4996638690044195,
                43.55308673576258
              ],
              [
                -6.4882706353317126,
                43.55512111663759
              ],
              [
                -6.462961396157033,
                43.55495851198273
              ],
              [
                -6.464751752558613,
                43.55967833447648
              ],
              [
                -6.467274540726255,
                43.57086817036522
              ],
              [
                -6.469105594744609,
                43.575384746220394
              ],
              [
                -6.455311650886302,
                43.573350271532725
              ],
              [
                -6.431792773335956,
                43.56342195101256
              ],
              [
                -6.417632616773048,
                43.56114331678249
              ],
              [
                -6.3661189449667095,
                43.56863030219354
              ],
              [
                -6.314605273958876,
                43.56863030219354
              ],
              [
                -6.30003820985506,
                43.57062395015201
              ],
              [
                -6.273915169386906,
                43.579616642120115
              ],
              [
                -6.24998938231485,
                43.58405169575752
              ],
              [
                -6.243885869035104,
                43.589300793752976
              ],
              [
                -6.236398891644549,
                43.594305721177086
              ],
              [
                -6.22276770651628,
                43.59589263160338
              ],
              [
                -6.190988738852442,
                43.57855874045033
              ],
              [
                -6.178049279891081,
                43.575384746220394
              ],
              [
                -6.100412567836712,
                43.5692000454782
              ],
              [
                -6.08495032193789,
                43.575384746220394
              ],
              [
                -6.069162562660818,
                43.56968817994372
              ],
              [
                -6.05418860761551,
                43.574571077020806
              ],
              [
                -6.039214646035867,
                43.583115896927055
              ],
              [
                -6.023508264771786,
                43.58844629222983
              ],
              [
                -5.907378707814723,
                43.58844629222983
              ],
              [
                -5.902170380634546,
                43.59752035513594
              ],
              [
                -5.908843550161644,
                43.60492573606421
              ],
              [
                -5.913075329083857,
                43.612860537990585
              ],
              [
                -5.900624154842007,
                43.62323644877046
              ],
              [
                -5.902577274301241,
                43.62649149608137
              ],
              [
                -5.905344202382417,
                43.633815745676614
              ],
              [
                -5.90737871100139,
                43.63682691918883
              ],
              [
                -5.875152144866184,
                43.63678610816205
              ],
              [
                -5.863514778423145,
                43.64142488442664
              ],
              [
                -5.859038867426614,
                43.653631944907495
              ],
              [
                -5.852202924491117,
                43.6629498044346
              ],
              [
                -5.8363337908559325,
                43.66221759920037
              ],
              [
                -5.803822397115551,
                43.650498827740485
              ],
              [
                -5.782338020814675,
                43.63703036525983
              ],
              [
                -5.727406380174701,
                43.58954502435879
              ],
              [
                -5.708851692866898,
                43.56863030219354
              ],
              [
                -5.701975064865867,
                43.56863030219354
              ],
              [
                -5.69676673253378,
                43.58283116842411
              ],
              [
                -5.689198373621209,
                43.57855874045033
              ],
              [
                -5.677479621683868,
                43.56114331678249
              ],
              [
                -5.625599742618414,
                43.55495851198273
              ],
              [
                -5.4242244136533735,
                43.56114331678249
              ],
              [
                -5.393869594731727,
                43.55524322241983
              ],
              [
                -5.390736460871656,
                43.541327339967516
              ],
              [
                -5.403553844593474,
                43.52541753179267
              ],
              [
                -5.4208064395808275,
                43.51337297318699
              ],
              [
                -5.413929820031975,
                43.50653727375477
              ],
              [
                -5.403675915064229,
                43.511094597925435
              ],
              [
                -5.382639128627842,
                43.51638423423596
              ],
              [
                -5.372425911964855,
                43.52020908301809
              ],
              [
                -5.365101693036497,
                43.52671950136077
              ],
              [
                -5.362212692990753,
                43.53339261250856
              ],
              [
                -5.356800908940452,
                43.538600912635324
              ],
              [
                -5.341949024455477,
                43.54063553103153
              ],
              [
                -5.299875458210298,
                43.53766521056388
              ],
              [
                -5.284006310475391,
                43.533473910844705
              ],
              [
                -5.211903447503943,
                43.4983583832465
              ],
              [
                -5.177886519252299,
                43.48936582790168
              ],
              [
                -5.091664190716898,
                43.48627346144236
              ],
              [
                -5.0676977181623455,
                43.48139062931237
              ],
              [
                -5.057036909118871,
                43.46861386627845
              ],
              [
                -5.045033333018846,
                43.474310648921225
              ],
              [
                -4.975168425799398,
                43.4587670565654
              ],
              [
                -4.967111783476752,
                43.460882896604026
              ],
              [
                -4.952544726218198,
                43.47007885062153
              ],
              [
                -4.941029428069708,
                43.47174720943601
              ],
              [
                -4.930246550522168,
                43.46950923539337
              ],
              [
                -4.907622850951152,
                43.46063873728085
              ],
              [
                -4.836537236525219,
                43.449774392468775
              ],
              [
                -4.7549942659791045,
                43.42165747258048
              ],
              [
                -4.734934052606503,
                43.417100459906244
              ],
              [
                -4.51231848550316,
                43.40273658674745
              ],
              [
                -4.508168100197632,
                43.40245197445482
              ],
              [
                -4.481678837180361,
                43.3836122629518
              ],
              [
                -4.460804819617147,
                43.39870850265455
              ],
              [
                -4.432525190726447,
                43.40261452305743
              ],
              [
                -4.404896611689397,
                43.39699932511351
              ],
              [
                -4.385568811240865,
                43.3836122629518
              ],
              [
                -4.379261845244822,
                43.3836122629518
              ],
              [
                -4.368763802658134,
                43.39618567976698
              ],
              [
                -4.359364388045143,
                43.39968500454124
              ],
              [
                -4.312814907812142,
                43.39577870545459
              ],
              [
                -4.188588018384478,
                43.40538151118839
              ],
              [
                -4.160959435617564,
                43.42116919724353
              ],
              [
                -4.097727017301257,
                43.4356143377272
              ],
              [
                -4.073963995328106,
                43.438259153459015
              ],
              [
                -4.029204881335499,
                43.438259153459015
              ],
              [
                -4.023426888135113,
                43.44094477782971
              ],
              [
                -4.022572395586745,
                43.44574618624313
              ],
              [
                -4.020904099676767,
                43.45038477606397
              ],
              [
                -4.012766076708284,
                43.452500576079416
              ],
              [
                -4.00568600353733,
                43.45079180040474
              ],
              [
                -3.981434699343355,
                43.438259153459015
              ],
              [
                -3.9764705050245936,
                43.442938458033716
              ],
              [
                -3.9719945940874624,
                43.444159207245065
              ],
              [
                -3.9671524744538162,
                43.444200000418874
              ],
              [
                -3.9610082646370954,
                43.445095015773475
              ],
              [
                -3.9654434906805958,
                43.446844867337745
              ],
              [
                -3.974598758739558,
                43.452500576079416
              ],
              [
                -3.9745987634374735,
                43.4587670565654
              ],
              [
                -3.940052864923663,
                43.47711827153506
              ],
              [
                -3.9227188810311997,
                43.48261148451647
              ],
              [
                -3.906320766455166,
                43.4791934028885
              ],
              [
                -3.893788214466279,
                43.48489001730969
              ],
              [
                -3.8908585263034565,
                43.48370995262816
              ],
              [
                -3.885853644458006,
                43.4791934028885
              ],
              [
                -3.8568009088848183,
                43.4923769252192
              ],
              [
                -3.826730924162069,
                43.497015699321146
              ],
              [
                -3.7970271471107706,
                43.49274319052913
              ],
              [
                -3.7691544254742833,
                43.4791934028885
              ],
              [
                -3.8126521465747,
                43.4648704453473
              ],
              [
                -3.8309626934051915,
                43.456000040143145
              ],
              [
                -3.8443090467067025,
                43.445095015773475
              ],
              [
                -3.83385169465084,
                43.435899275681045
              ],
              [
                -3.829253707091417,
                43.4331320975211
              ],
              [
                -3.8238419269719044,
                43.43077224700238
              ],
              [
                -3.8272598958437554,
                43.43003981916765
              ],
              [
                -3.8299861306173177,
                43.43012109850616
              ],
              [
                -3.8315323567214383,
                43.42906325060077
              ],
              [
                -3.8312882179492687,
                43.42458744028488
              ],
              [
                -3.820220505504979,
                43.4242617182451
              ],
              [
                -3.811187302395017,
                43.42548241609135
              ],
              [
                -3.7964981769649535,
                43.43077224700238
              ],
              [
                -3.789540168378029,
                43.435858483270444
              ],
              [
                -3.7761938119233482,
                43.44965231585059
              ],
              [
                -3.7722875609055526,
                43.452500576079416
              ],
              [
                -3.7634985006356336,
                43.4502626992777
              ],
              [
                -3.754139780974163,
                43.44049727411371
              ],
              [
                -3.7449845033823816,
                43.438259153459015
              ],
              [
                -3.7407120406803265,
                43.4423280846879
              ],
              [
                -3.7430313789256178,
                43.451361391564404
              ],
              [
                -3.7488907519025694,
                43.46072002222763
              ],
              [
                -3.75552324301669,
                43.465521644876496
              ],
              [
                -3.7555232425730964,
                43.47174720943601
              ],
              [
                -3.741525847692369,
                43.47024172844047
              ],
              [
                -3.735747852922468,
                43.46881753899857
              ],
              [
                -3.7288712250023845,
                43.465521644876496
              ],
              [
                -3.7271622379268385,
                43.47052638421188
              ],
              [
                -3.725819463927203,
                43.47052638421188
              ],
              [
                -3.721424935558792,
                43.47174720943601
              ],
              [
                -3.728871222479901,
                43.4791934028885
              ],
              [
                -3.71792558724142,
                43.482733570222244
              ],
              [
                -3.6883845710211483,
                43.48423909372897
              ],
              [
                -3.676991341905705,
                43.48944742258382
              ],
              [
                -3.667062953927658,
                43.49664943046908
              ],
              [
                -3.6560766268648663,
                43.500677795616
              ],
              [
                -3.5794164684967926,
                43.518255854471256
              ],
              [
                -3.5543513651152896,
                43.5169131100127
              ],
              [
                -3.5562638038137364,
                43.499701375718516
              ],
              [
                -3.5390518873453014,
                43.49896883386385
              ],
              [
                -3.525624155080009,
                43.49164469996937
              ],
              [
                -3.514719202192738,
                43.48322160892895
              ],
              [
                -3.5053604805110417,
                43.4791934028885
              ],
              [
                -3.4366348979622163,
                43.47048589305888
              ],
              [
                -3.431507940178154,
                43.46686423318385
              ],
              [
                -3.4282934256508795,
                43.461737455294916
              ],
              [
                -3.4271540999944494,
                43.45563380524529
              ],
              [
                -3.428618945453074,
                43.446844867337745
              ],
              [
                -3.432606577243481,
                43.445420753102525
              ],
              [
                -3.43887285019214,
                43.446559922353515
              ],
              [
                -3.447010868943675,
                43.445095015773475
              ],
              [
                -3.451161264252909,
                43.44769939896002
              ],
              [
                -3.460601366897871,
                43.45221593189228
              ],
              [
                -3.4700414671253026,
                43.45416886868057
              ],
              [
                -3.474354618218164,
                43.448797780464446
              ],
              [
                -3.477772588368163,
                43.44306053280365
              ],
              [
                -3.4858292321244035,
                43.437567505833925
              ],
              [
                -3.5016983718899954,
                43.43077224700238
              ],
              [
                -3.481800909521512,
                43.42804589248892
              ],
              [
                -3.470448369724474,
                43.41677474335484
              ],
              [
                -3.46108964706114,
                43.41246160902205
              ],
              [
                -3.447010871876094,
                43.43077224700238
              ],
              [
                -3.436187303875446,
                43.41901275572674
              ],
              [
                -3.4222306002167664,
                43.418077002175245
              ],
              [
                -3.3924861346114907,
                43.42458744028488
              ],
              [
                -3.3780411439248943,
                43.422552746895875
              ],
              [
                -3.330311651565728,
                43.41034569540936
              ],
              [
                -3.2689509740193654,
                43.404120079041405
              ],
              [
                -3.2235408189488703,
                43.391628319254856
              ],
              [
                -3.210519984868077,
                43.38983789690179
              ],
              [
                -3.2000219373799323,
                43.38552471925472
              ],
              [
                -3.1769099597920967,
                43.3662376856552
              ],
              [
                -3.1508682955031118,
                43.360215699790785
              ],
              [
                -3.1314998060287342,
                43.35578045338182
              ],
              [
                -3.112375456514126,
                43.35407144039432
              ],
              [
                -3.0895076160302275,
                43.366888740700325
              ],
              [
                -3.0578507160918122,
                43.3523624339462
              ],
              [
                -3.008168100328402,
                43.32090905539697
              ],
              [
                -3.0081681003296685,
                43.328436725442316
              ],
              [
                -3.0200089167301964,
                43.35256574906341
              ],
              [
                -3.0234268863795153,
                43.364935578414695
              ],
              [
                -3.029286260872182,
                43.372137697452494
              ],
              [
                -3.029286263171569,
                43.37616615005427
              ],
              [
                -3.024322066477857,
                43.38092668044226
              ],
              [
                -3.010975713987856,
                43.384141284739876
              ],
              [
                -2.999419724121628,
                43.39435445048734
              ],
              [
                -2.9559220042144405,
                43.41384513156769
              ],
              [
                -2.9399307952392357,
                43.417100459906244
              ],
              [
                -2.9399307952630966,
                43.42458744028488
              ],
              [
                -2.946685353268308,
                43.42458744028488
              ],
              [
                -2.9466853517489304,
                43.43077224700238
              ],
              [
                -2.9300837890971327,
                43.43793372581101
              ],
              [
                -2.9052628269828644,
                43.43988690412673
              ],
              [
                -2.8542374335292373,
                43.438259153459015
              ],
              [
                -2.806996224178486,
                43.441677223661415
              ],
              [
                -2.785959437681652,
                43.447861964122005
              ],
              [
                -2.768625452728851,
                43.452500576079416
              ],
              [
                -2.755848761000885,
                43.4502626992777
              ],
              [
                -2.7349340503789312,
                43.438788240266184
              ],
              [
                -2.7151993469107616,
                43.42450585754596
              ],
              [
                -2.7065323546786884,
                43.41368227445479
              ],
              [
                -2.69493567665107,
                43.38861729687338
              ],
              [
                -2.691029426243513,
                43.36753979669541
              ],
              [
                -2.687001107884623,
                43.371446152618574
              ],
              [
                -2.6792699850553707,
                43.38983789690179
              ],
              [
                -2.678456183567026,
                43.39463936199485
              ],
              [
                -2.678781706385603,
                43.400580234618495
              ],
              [
                -2.6778051435110055,
                43.40619547774947
              ],
              [
                -2.672963018848843,
                43.41034569540936
              ],
              [
                -2.6612035779959538,
                43.411932553573756
              ],
              [
                -2.649322069881804,
                43.40953202565596
              ],
              [
                -2.6380916026675822,
                43.40595134850486
              ],
              [
                -2.6069229796850673,
                43.401882141620334
              ],
              [
                -2.5488988903963685,
                43.3836122629518
              ],
              [
                -2.5060115223859616,
                43.37714260252675
              ],
              [
                -2.483509895294318,
                43.370632249552884
              ],
              [
                -2.4644262372665224,
                43.349229323166035
              ],
              [
                -2.3674210277351286,
                43.315700568577924
              ],
              [
                -2.3270564432555685,
                43.30683008943884
              ],
              [
                -2.2846573578826144,
                43.3034937001502
              ],
              [
                -2.2411189431835266,
                43.30723698272551
              ],
              [
                -2.2078751303312663,
                43.31399170871626
              ],
              [
                -2.1962784501431973,
                43.314764727329816
              ],
              [
                -2.19041907383261,
                43.31159079444747
              ],
              [
                -2.1834610665640644,
                43.304510774323596
              ],
              [
                -2.174468555689481,
                43.297430865996375
              ],
              [
                -2.1622208301145758,
                43.294256751491176
              ],
              [
                -2.1595759776426973,
                43.29535566817113
              ],
              [
                -2.1563207677935456,
                43.297674935941785
              ],
              [
                -2.151519335095328,
                43.29999421570298
              ],
              [
                -2.144846158013638,
                43.301092842108694
              ],
              [
                -2.1400447262091875,
                43.29889559198828
              ],
              [
                -2.137806770779368,
                43.294216276350504
              ],
              [
                -2.134836391302506,
                43.28957748422666
              ],
              [
                -2.127797005265138,
                43.28742106933577
              ],
              [
                -2.0988663407958597,
                43.304144663875114
              ],
              [
                -2.086415167239864,
                43.30723698272551
              ],
              [
                -2.0655411452473733,
                43.309597092805745
              ],
              [
                -1.994618294544683,
                43.328436725442316
              ],
              [
                -1.9717911463431628,
                43.33921958622019
              ],
              [
                -1.960357224672686,
                43.34308491051744
              ],
              [
                -1.9456274087638308,
                43.342637505128685
              ],
              [
                -1.9337052084018185,
                43.3356388648246
              ],
              [
                -1.926584440098778,
                43.325873213015704
              ],
              [
                -1.9186905591418566,
                43.320990314845005
              ],
              [
                -1.9046524744750324,
                43.328436725442316
              ],
              [
                -1.910227018176971,
                43.33136638495373
              ],
              [
                -1.9188533205976712,
                43.338568571502506
              ],
              [
                -1.9256892577559832,
                43.342637505128685
              ],
              [
                -1.8849177738056428,
                43.35602455514727
              ],
              [
                -1.847401494459311,
                43.38092668044226
              ],
              [
                -1.811268685493963,
                43.395087123931155
              ],
              [
                -1.7940747454915296,
                43.386015390570016
              ]
            ]
          ],
          [
            [
              [
                1.983372029373525,
                42.44126062468009
              ],
              [
                1.960634399541555,
                42.443715361235604
              ],
              [
                1.9475085853611809,
                42.451234266043215
              ],
              [
                1.945648232782696,
                42.46381742509312
              ],
              [
                1.956603637419684,
                42.48177495218372
              ],
              [
                1.9679724526603142,
                42.48570238226417
              ],
              [
                1.9783077393189574,
                42.47497949268389
              ],
              [
                1.9884363206446511,
                42.45818477075872
              ],
              [
                1.999495076837318,
                42.44389625464318
              ],
              [
                1.9960844326189073,
                42.44283686726719
              ],
              [
                1.9861625563727026,
                42.44126062468009
              ],
              [
                1.983372029373525,
                42.44126062468009
              ]
            ]
          ],
          [
            [
              [
                -17.93394935308647,
                27.852036953875277
              ],
              [
                -17.914051887962188,
                27.849554774487192
              ],
              [
                -17.896473769404125,
                27.840318251188158
              ],
              [
                -17.88402258367792,
                27.82758196955898
              ],
              [
                -17.87926184955865,
                27.81452060670528
              ],
              [
                -17.88512121816317,
                27.797918913533586
              ],
              [
                -17.926421676102755,
                27.74282455192542
              ],
              [
                -17.927601685270428,
                27.73651750773006
              ],
              [
                -17.926909952993885,
                27.73037329702123
              ],
              [
                -17.926909962799904,
                27.724351361166153
              ],
              [
                -17.930165173144925,
                27.718654795067312
              ],
              [
                -17.935129356231645,
                27.71564352463162
              ],
              [
                -17.94066320973973,
                27.71369038960574
              ],
              [
                -17.945139128361927,
                27.71076083680566
              ],
              [
                -17.9469294851409,
                27.704657174344177
              ],
              [
                -17.95030676447507,
                27.699530228148777
              ],
              [
                -17.957753059155824,
                27.69399648918462
              ],
              [
                -17.965240039477788,
                27.686997819188605
              ],
              [
                -17.96861731792123,
                27.677679773828462
              ],
              [
                -17.97130286551807,
                27.654364356073224
              ],
              [
                -17.979481575601834,
                27.64252351732503
              ],
              [
                -17.994130013395836,
                27.64223870256026
              ],
              [
                -18.015777143589357,
                27.653469052941656
              ],
              [
                -18.03066972956327,
                27.66787351262432
              ],
              [
                -18.03978430575103,
                27.681341797881764
              ],
              [
                -18.05313065855755,
                27.69122946872325
              ],
              [
                -18.126942508541998,
                27.70026269206039
              ],
              [
                -18.146636518171377,
                27.70856344650152
              ],
              [
                -18.16038977199688,
                27.722357367996842
              ],
              [
                -18.167225708437766,
                27.757554297106477
              ],
              [
                -18.140492315187306,
                27.76878486154292
              ],
              [
                -18.097767701214885,
                27.765366812343487
              ],
              [
                -18.056792771945446,
                27.75649646467473
              ],
              [
                -18.041981580338057,
                27.76520427697865
              ],
              [
                -18.00324459563937,
                27.79881420793106
              ],
              [
                -17.99535071058026,
                27.808050758640267
              ],
              [
                -17.99413000572478,
                27.81875221921224
              ],
              [
                -17.989857553452683,
                27.823716588551555
              ],
              [
                -17.968617311840298,
                27.832220665701723
              ],
              [
                -17.93394935308647,
                27.852036953875277
              ]
            ]
          ],
          [
            [
              [
                -15.391590948962042,
                28.03021879284536
              ],
              [
                -15.383452925214911,
                28.024318663827295
              ],
              [
                -15.367583783270534,
                28.0158144096486
              ],
              [
                -15.363636842776245,
                28.00971088303171
              ],
              [
                -15.366281705135563,
                27.99347565616954
              ],
              [
                -15.374134898206545,
                27.97549070199911
              ],
              [
                -15.376698376198473,
                27.957505722721535
              ],
              [
                -15.363636853200118,
                27.941473821999946
              ],
              [
                -15.363636849981699,
                27.9346378085158
              ],
              [
                -15.374623169684764,
                27.929876871826856
              ],
              [
                -15.381906704738286,
                27.921210021859807
              ],
              [
                -15.391590953740314,
                27.899847810849643
              ],
              [
                -15.382720508064555,
                27.88548414204417
              ],
              [
                -15.375965949446455,
                27.86758045795851
              ],
              [
                -15.377837690338424,
                27.852280905638004
              ],
              [
                -15.394683404277451,
                27.845892792969252
              ],
              [
                -15.40697180849712,
                27.838324274151816
              ],
              [
                -15.439198376989811,
                27.80267989621251
              ],
              [
                -15.453033012478723,
                27.791245964152022
              ],
              [
                -15.523426884831482,
                27.77167384404479
              ],
              [
                -15.534901499089008,
                27.766424944563177
              ],
              [
                -15.539662238831308,
                27.76561106603992
              ],
              [
                -15.566029419768402,
                27.739406496632974
              ],
              [
                -15.577951623187698,
                27.734360980494113
              ],
              [
                -15.588246219921485,
                27.738918288793553
              ],
              [
                -15.597727012527121,
                27.746283165206446
              ],
              [
                -15.60724850680891,
                27.750311703567917
              ],
              [
                -15.650502084732818,
                27.753119271781344
              ],
              [
                -15.66954505013394,
                27.757147507819212
              ],
              [
                -15.68569902912185,
                27.763332566453403
              ],
              [
                -15.73965409486656,
                27.804347907182095
              ],
              [
                -15.747873503372839,
                27.81452060670528
              ],
              [
                -15.751861126290887,
                27.821356380254237
              ],
              [
                -15.772816539629549,
                27.831976713585533
              ],
              [
                -15.781971804398918,
                27.838446250154735
              ],
              [
                -15.786000134894822,
                27.84422448652138
              ],
              [
                -15.815052863219783,
                27.901271859169224
              ],
              [
                -15.821197066821115,
                27.921779640293103
              ],
              [
                -15.816070121353244,
                27.941473821999946
              ],
              [
                -15.820057752181983,
                27.952867069738996
              ],
              [
                -15.821766725309983,
                27.968329039619114
              ],
              [
                -15.820627401849636,
                27.984076099294413
              ],
              [
                -15.816070120189048,
                27.996039225104624
              ],
              [
                -15.806996225109467,
                28.005031690889574
              ],
              [
                -15.76768958498855,
                28.023993298925244
              ],
              [
                -15.749826625441676,
                28.035956086573044
              ],
              [
                -15.725209109537156,
                28.05687073352835
              ],
              [
                -15.708363416160376,
                28.08193605725597
              ],
              [
                -15.71369381204119,
                28.10590236658199
              ],
              [
                -15.702137820588236,
                28.11505758394838
              ],
              [
                -15.698109500721081,
                28.133042635712716
              ],
              [
                -15.70006263494291,
                28.152899615444866
              ],
              [
                -15.706206839137492,
                28.16738525147186
              ],
              [
                -15.695057752402139,
                28.168199104727403
              ],
              [
                -15.684396934497991,
                28.167629197156458
              ],
              [
                -15.674427867529648,
                28.16526935291319
              ],
              [
                -15.665272596247553,
                28.160549362576237
              ],
              [
                -15.650786916665709,
                28.163885892127
              ],
              [
                -15.597035282009632,
                28.147528296099324
              ],
              [
                -15.521310998029014,
                28.147528296099324
              ],
              [
                -15.458729620492496,
                28.134222711326583
              ],
              [
                -15.435047983229644,
                28.140936642350717
              ],
              [
                -15.438710090936793,
                28.174872158520785
              ],
              [
                -15.409291146027847,
                28.179754973648812
              ],
              [
                -15.405262824376955,
                28.177923880662306
              ],
              [
                -15.399891729904343,
                28.165025106753678
              ],
              [
                -15.400135866647599,
                28.157212531652092
              ],
              [
                -15.408558725352457,
                28.153754027223464
              ],
              [
                -15.415638800947304,
                28.141506250786232
              ],
              [
                -15.414947066889777,
                28.11448797425055
              ],
              [
                -15.408558717708363,
                28.074896429365
              ],
              [
                -15.406239381556054,
                28.068060487756874
              ],
              [
                -15.40392004872143,
                28.056301121110142
              ],
              [
                -15.399647593563547,
                28.04267007182228
              ],
              [
                -15.391590948962042,
                28.03021879284536
              ]
            ]
          ],
          [
            [
              [
                -17.309673194555963,
                28.20711738680892
              ],
              [
                -17.259173292344894,
                28.21771666555477
              ],
              [
                -17.21272108780469,
                28.2054494287851
              ],
              [
                -17.17039953581686,
                28.18109757470566
              ],
              [
                -17.11611894133847,
                28.146226248746707
              ],
              [
                -17.104279467086652,
                28.123035121146472
              ],
              [
                -17.09841969565262,
                28.10076355691175
              ],
              [
                -17.113937357844705,
                28.08096717733491
              ],
              [
                -17.13352517328173,
                28.069778636575002
              ],
              [
                -17.163186531462227,
                28.04501371688612
              ],
              [
                -17.184975313587408,
                28.031619092929144
              ],
              [
                -17.207110518960903,
                28.026693256541343
              ],
              [
                -17.23270554598673,
                28.01910621493778
              ],
              [
                -17.25788759409764,
                28.024569522264024
              ],
              [
                -17.310073182826176,
                28.053473487768137
              ],
              [
                -17.343220903354517,
                28.097660441847356
              ],
              [
                -17.343376510662253,
                28.133356281075688
              ],
              [
                -17.33881692914838,
                28.17104714003763
              ],
              [
                -17.309673194555963,
                28.20711738680892
              ]
            ]
          ],
          [
            [
              [
                -16.42769548408192,
                28.149669433646793
              ],
              [
                -16.44102942374855,
                28.132757831295525
              ],
              [
                -16.456776499585803,
                28.115464662592473
              ],
              [
                -16.521546657278254,
                28.057573135303258
              ],
              [
                -16.536327272919745,
                28.03647432656909
              ],
              [
                -16.545765757136028,
                28.023993298925244
              ],
              [
                -16.579710208050003,
                28.030332355054938
              ],
              [
                -16.63442150282385,
                28.011656465078946
              ],
              [
                -16.657439616013335,
                28.003653619654763
              ],
              [
                -16.67633972972492,
                27.997096438019344
              ],
              [
                -16.692683271818964,
                27.999846873594155
              ],
              [
                -16.703551699059,
                28.013683162798113
              ],
              [
                -16.7057519811501,
                28.0230003801278
              ],
              [
                -16.704090956218867,
                28.03497969231923
              ],
              [
                -16.71324622020622,
                28.038275398156042
              ],
              [
                -16.721058729606558,
                28.04450118539214
              ],
              [
                -16.72411048102192,
                28.052679755470784
              ],
              [
                -16.725941530195122,
                28.071478459037003
              ],
              [
                -16.72789465413285,
                28.07859920444162
              ],
              [
                -16.741607222379987,
                28.09381737288763
              ],
              [
                -16.78062903268429,
                28.127874996700086
              ],
              [
                -16.788685680094666,
                28.14378498468093
              ],
              [
                -16.795399546782058,
                28.16526935291319
              ],
              [
                -16.810536263640014,
                28.181870869582877
              ],
              [
                -16.826812310914303,
                28.195746306514977
              ],
              [
                -16.83714758815222,
                28.20897040617411
              ],
              [
                -16.843983535134694,
                28.253078667409458
              ],
              [
                -16.84723873351683,
                28.26251857004479
              ],
              [
                -16.86119544334973,
                28.28188713918124
              ],
              [
                -16.87340247042801,
                28.305243177427386
              ],
              [
                -16.90660559781698,
                28.33515045420429
              ],
              [
                -16.916058090998387,
                28.354969826674935
              ],
              [
                -16.891935289011645,
                28.36865638409263
              ],
              [
                -16.837439853528277,
                28.391082736955745
              ],
              [
                -16.817766416660728,
                28.3835632296714
              ],
              [
                -16.794178847068885,
                28.369126842294385
              ],
              [
                -16.78254147327335,
                28.366034315268664
              ],
              [
                -16.77013098275293,
                28.366278256620834
              ],
              [
                -16.741566535828106,
                28.37348053240951
              ],
              [
                -16.719619394602734,
                28.383261908513393
              ],
              [
                -16.68718994695909,
                28.392780108017835
              ],
              [
                -16.664179503914358,
                28.400726805160595
              ],
              [
                -16.644398559856253,
                28.396429605088866
              ],
              [
                -16.604406378548305,
                28.39966692543968
              ],
              [
                -16.584633973492366,
                28.401099625638
              ],
              [
                -16.56447888355552,
                28.41533528952307
              ],
              [
                -16.538929821232554,
                28.417873529258
              ],
              [
                -16.52818762991307,
                28.422105229263213
              ],
              [
                -16.507135172510793,
                28.42413395719014
              ],
              [
                -16.486903527366472,
                28.438273455866437
              ],
              [
                -16.439930792443718,
                28.475246474246187
              ],
              [
                -16.42039953727689,
                28.49062722504004
              ],
              [
                -16.41429602208679,
                28.499212833048578
              ],
              [
                -16.41197669860811,
                28.51373946452123
              ],
              [
                -16.408273886095618,
                28.519842716362557
              ],
              [
                -16.389393682914033,
                28.528753950065052
              ],
              [
                -16.381214968829628,
                28.534247048907243
              ],
              [
                -16.36335202178731,
                28.543036301177246
              ],
              [
                -16.341053833109118,
                28.546576093204237
              ],
              [
                -16.322743294247086,
                28.553452893405066
              ],
              [
                -16.316395631357796,
                28.572088814649202
              ],
              [
                -16.300160292285767,
                28.566636593149145
              ],
              [
                -16.202707486252613,
                28.564032299385225
              ],
              [
                -16.141346808684755,
                28.583441466266247
              ],
              [
                -16.117746543426517,
                28.572088814649202
              ],
              [
                -16.127070475749747,
                28.543818582405898
              ],
              [
                -16.157397781932524,
                28.524482939708438
              ],
              [
                -16.231391363389925,
                28.48841555633979
              ],
              [
                -16.24801474499499,
                28.461122948310578
              ],
              [
                -16.26867185277988,
                28.44331597629042
              ],
              [
                -16.296135929947067,
                28.417762374258217
              ],
              [
                -16.323895602673062,
                28.39746935702835
              ],
              [
                -16.34163360518568,
                28.391334789065183
              ],
              [
                -16.35551364357233,
                28.381149655968468
              ],
              [
                -16.365771934076164,
                28.362455406590193
              ],
              [
                -16.366106518427863,
                28.34142535101155
              ],
              [
                -16.360577138260833,
                28.324581028689256
              ],
              [
                -16.358106234274345,
                28.31463106272456
              ],
              [
                -16.361332210881738,
                28.304423325563807
              ],
              [
                -16.371000225715537,
                28.29711855992856
              ],
              [
                -16.38001598255775,
                28.28834201957305
              ],
              [
                -16.386773165404694,
                28.264989851244437
              ],
              [
                -16.419232880612345,
                28.211382815827015
              ],
              [
                -16.42796632545471,
                28.167685977616784
              ],
              [
                -16.42769548408192,
                28.149669433646793
              ]
            ]
          ],
          [
            [
              [
                -13.972645635963591,
                28.73590726868095
              ],
              [
                -13.935414191216244,
                28.749497769819346
              ],
              [
                -13.898671033222698,
                28.753892448126937
              ],
              [
                -13.864572723914039,
                28.744208171319894
              ],
              [
                -13.835519988555662,
                28.715480924145464
              ],
              [
                -13.824370903829145,
                28.681789599467344
              ],
              [
                -13.821156380476308,
                28.636664166708726
              ],
              [
                -13.828684044434528,
                28.551581007893983
              ],
              [
                -13.835194465783575,
                28.530747808604854
              ],
              [
                -13.852935356179213,
                28.492743360737613
              ],
              [
                -13.856556769877006,
                28.478989972918644
              ],
              [
                -13.857736786947855,
                28.44550211917551
              ],
              [
                -13.856556775162693,
                28.434882032798406
              ],
              [
                -13.85362708369106,
                28.428412219544587
              ],
              [
                -13.844349743983425,
                28.414292835577644
              ],
              [
                -13.842925583346664,
                28.406927760314563
              ],
              [
                -13.847767705094158,
                28.397406268933263
              ],
              [
                -13.865712047949986,
                28.38288007481034
              ],
              [
                -13.869618289321178,
                28.37689841223321
              ],
              [
                -13.870106570057688,
                28.36774310629837
              ],
              [
                -13.8718155602785,
                28.357977638278886
              ],
              [
                -13.875152151379385,
                28.349066558348056
              ],
              [
                -13.892079228839679,
                28.32819239543224
              ],
              [
                -13.900217252076947,
                28.311102607946275
              ],
              [
                -13.911284954911931,
                28.277248311204545
              ],
              [
                -13.933705206400427,
                28.244208059814145
              ],
              [
                -13.966786267024295,
                28.227972850109467
              ],
              [
                -14.072580531585231,
                28.212835969441645
              ],
              [
                -14.118560348484824,
                28.200506839936406
              ],
              [
                -14.152007621129654,
                28.179999219500395
              ],
              [
                -14.19163977539489,
                28.170843751884973
              ],
              [
                -14.21222897566809,
                28.160549362576237
              ],
              [
                -14.244536915526236,
                28.129217904094514
              ],
              [
                -14.271392377499781,
                28.096136673562537
              ],
              [
                -14.30134029635229,
                28.067857097856376
              ],
              [
                -14.343169720818812,
                28.05068581078865
              ],
              [
                -14.369007938261998,
                28.05076722694814
              ],
              [
                -14.408314587692672,
                28.06696212216866
              ],
              [
                -14.42861894000771,
                28.071193653169008
              ],
              [
                -14.49486243672004,
                28.06781654004718
              ],
              [
                -14.507069460985983,
                28.071193653169008
              ],
              [
                -14.50340735496745,
                28.0747744555787
              ],
              [
                -14.499256967100596,
                28.086574662695615
              ],
              [
                -14.496449343431037,
                28.09853738963571
              ],
              [
                -14.496896944331766,
                28.102525263086466
              ],
              [
                -14.489735481512191,
                28.104315509599434
              ],
              [
                -14.45555579853536,
                28.09910730051447
              ],
              [
                -14.436024543385674,
                28.10053132652542
              ],
              [
                -14.398915169276602,
                28.111232846582748
              ],
              [
                -14.341175909455787,
                28.134507515708737
              ],
              [
                -14.27013099079612,
                28.175970814634766
              ],
              [
                -14.240142385631293,
                28.201564936268753
              ],
              [
                -14.224435996630486,
                28.218573175534566
              ],
              [
                -14.213531051593948,
                28.234930671217533
              ],
              [
                -14.207386852096542,
                28.254380702697986
              ],
              [
                -14.201893689377954,
                28.303900591108082
              ],
              [
                -14.193226691795878,
                28.321844788952664
              ],
              [
                -14.171294730171352,
                28.352362475124345
              ],
              [
                -14.146392378622311,
                28.423325830756767
              ],
              [
                -14.14085853326859,
                28.434882032798406
              ],
              [
                -14.127919077931729,
                28.443589657251287
              ],
              [
                -14.098296682090922,
                28.48663979211119
              ],
              [
                -14.075550913265225,
                28.536118937682733
              ],
              [
                -14.03612219554617,
                28.587388304594985
              ],
              [
                -14.024566212452578,
                28.63711178109694
              ],
              [
                -14.010121225357288,
                28.667466596703726
              ],
              [
                -14.005279103292747,
                28.70359940700789
              ],
              [
                -13.999908010685129,
                28.71674234497548
              ],
              [
                -13.98949133464768,
                28.7268739603144
              ],
              [
                -13.972645635963591,
                28.73590726868095
              ]
            ]
          ],
          [
            [
              [
                -17.755767387160976,
                28.818508303682457
              ],
              [
                -17.75780188603931,
                28.798651415610546
              ],
              [
                -17.75060242977535,
                28.774762710238143
              ],
              [
                -17.74143809281587,
                28.757911914171643
              ],
              [
                -17.721882904104902,
                28.74902883177462
              ],
              [
                -17.721044159688134,
                28.730643797992027
              ],
              [
                -17.751099503193267,
                28.69998396928183
              ],
              [
                -17.765253525522745,
                28.677548697541145
              ],
              [
                -17.75753213184188,
                28.657676485295518
              ],
              [
                -17.745604191405235,
                28.62188687193308
              ],
              [
                -17.753660402158623,
                28.60302633648221
              ],
              [
                -17.759856399773057,
                28.57682094030762
              ],
              [
                -17.78334029811369,
                28.5485960842869
              ],
              [
                -17.803297799861443,
                28.50945613071139
              ],
              [
                -17.821685346759367,
                28.475816065337238
              ],
              [
                -17.830881317075573,
                28.4553897760065
              ],
              [
                -17.837066213076625,
                28.4553897760065
              ],
              [
                -17.842884890580322,
                28.4650331838861
              ],
              [
                -17.86512205839729,
                28.47538106117352
              ],
              [
                -17.872153175437177,
                28.49442629514404
              ],
              [
                -17.879687701681327,
                28.543712535837425
              ],
              [
                -17.891166426189326,
                28.55565102909267
              ],
              [
                -17.898589851854137,
                28.57164870762056
              ],
              [
                -17.919289373240254,
                28.596303382771755
              ],
              [
                -17.92483835347863,
                28.61833899599358
              ],
              [
                -17.963098059192998,
                28.67148880377098
              ],
              [
                -17.967145676308988,
                28.696735932137017
              ],
              [
                -17.971413897215093,
                28.71256304291781
              ],
              [
                -17.97614498922503,
                28.728176235277484
              ],
              [
                -17.992298961498175,
                28.738592926331627
              ],
              [
                -18.00218665361143,
                28.749579180585705
              ],
              [
                -17.996815559232264,
                28.780096751394456
              ],
              [
                -17.970692509513345,
                28.81321844500748
              ],
              [
                -17.936350063177304,
                28.840318085451415
              ],
              [
                -17.91114507296276,
                28.85561893675624
              ],
              [
                -17.89053454090161,
                28.843945784082184
              ],
              [
                -17.865834119440624,
                28.840643725236692
              ],
              [
                -17.84166419203547,
                28.83543528967537
              ],
              [
                -17.801380994877583,
                28.849310725867365
              ],
              [
                -17.781483533097386,
                28.8422713231727
              ],
              [
                -17.765004030660435,
                28.829413051032375
              ],
              [
                -17.755767387160976,
                28.818508303682457
              ]
            ]
          ],
          [
            [
              [
                -13.482980926661504,
                29.239935679188864
              ],
              [
                -13.465402802425793,
                29.24331297699951
              ],
              [
                -13.446603974400617,
                29.232977714124615
              ],
              [
                -13.41779538028508,
                29.20892983601571
              ],
              [
                -13.427601692753568,
                29.18870679159635
              ],
              [
                -13.431507947668816,
                29.172430870991295
              ],
              [
                -13.438791468340922,
                29.159002956017122
              ],
              [
                -13.458729617274376,
                29.14740622503501
              ],
              [
                -13.46239173630623,
                29.132147659081284
              ],
              [
                -13.459136522709603,
                29.11859771582011
              ],
              [
                -13.454009573267623,
                29.104071461683553
              ],
              [
                -13.451893686147368,
                29.086005003250147
              ],
              [
                -13.453846811840794,
                29.078924942467197
              ],
              [
                -13.462269665746593,
                29.065741395767514
              ],
              [
                -13.465565561443862,
                29.058050908651584
              ],
              [
                -13.466216598499178,
                29.04975000490803
              ],
              [
                -13.464588993334292,
                29.03217187572993
              ],
              [
                -13.465565556963965,
                29.023911800360413
              ],
              [
                -13.482045053451742,
                28.99945715900642
              ],
              [
                -13.510487430683925,
                28.977484359545286
              ],
              [
                -13.543039515176497,
                28.961737326720396
              ],
              [
                -13.589955209304678,
                28.951361452072177
              ],
              [
                -13.599720828771328,
                28.942043281057977
              ],
              [
                -13.607574018132729,
                28.932603136480445
              ],
              [
                -13.619781049105548,
                28.928371364882167
              ],
              [
                -13.635487436986244,
                28.92723223782116
              ],
              [
                -13.658436649989275,
                28.922593417680446
              ],
              [
                -13.674387180084983,
                28.92153569904873
              ],
              [
                -13.70929928773022,
                28.91469972739751
              ],
              [
                -13.736073366857786,
                28.896470343150764
              ],
              [
                -13.757191533056124,
                28.870306635601562
              ],
              [
                -13.774647590702674,
                28.839585696296584
              ],
              [
                -13.780873176703016,
                28.839585696296584
              ],
              [
                -13.791493297926479,
                28.85346112599477
              ],
              [
                -13.812123178465491,
                28.85907629944016
              ],
              [
                -13.859689909769093,
                28.85944249321881
              ],
              [
                -13.867298953698226,
                28.8648948434152
              ],
              [
                -13.873646615791579,
                28.876857858673862
              ],
              [
                -13.876332154930848,
                28.888820557203104
              ],
              [
                -13.873036267996302,
                28.8942326350089
              ],
              [
                -13.861927867460782,
                28.89740640131957
              ],
              [
                -13.853423635831968,
                28.904974770373773
              ],
              [
                -13.84292559115997,
                28.92153569904873
              ],
              [
                -13.839100713033883,
                28.937892923149093
              ],
              [
                -13.835072389113604,
                28.987209234156758
              ],
              [
                -13.832102014299013,
                29.000392905499364
              ],
              [
                -13.798491995936745,
                29.048081892639217
              ],
              [
                -13.780873175094106,
                29.064886764044097
              ],
              [
                -13.766835086864804,
                29.07404198297813
              ],
              [
                -13.75055905091617,
                29.08063390250072
              ],
              [
                -13.731434702115392,
                29.084662228393924
              ],
              [
                -13.708892384188413,
                29.086005003250147
              ],
              [
                -13.690174929614933,
                29.09088765519319
              ],
              [
                -13.656483523504388,
                29.116034137410765
              ],
              [
                -13.636830203223791,
                29.126939102880208
              ],
              [
                -13.618275516358628,
                29.132391580080295
              ],
              [
                -13.60236568609822,
                29.134263343066454
              ],
              [
                -13.551177540718541,
                29.134222789708343
              ],
              [
                -13.537220833830267,
                29.138251088946284
              ],
              [
                -13.526112438325992,
                29.15029542123728
              ],
              [
                -13.513986788877908,
                29.174750211246867
              ],
              [
                -13.503163214301825,
                29.208156625892183
              ],
              [
                -13.495472785838809,
                29.225083722053288
              ],
              [
                -13.482980926661504,
                29.239935679188864
              ]
            ]
          ],
          [
            [
              [
                -13.486683722582015,
                29.284613337796337
              ],
              [
                -13.477894665530451,
                29.266262221817215
              ],
              [
                -13.492014122017892,
                29.242661729079238
              ],
              [
                -13.517079227807935,
                29.226263660947794
              ],
              [
                -13.541249147644262,
                29.2293967463008
              ],
              [
                -13.54124915800469,
                29.236802598078068
              ],
              [
                -13.5257462179651,
                29.251206650162764
              ],
              [
                -13.517933722039563,
                29.27350492658962
              ],
              [
                -13.508168103899525,
                29.289455614765462
              ],
              [
                -13.486683722582015,
                29.284613337796337
              ]
            ]
          ],
          [
            [
              [
                -0.7327367829514301,
                37.747748099471636
              ],
              [
                -0.7418513661195278,
                37.72553135240548
              ],
              [
                -0.7401423822496233,
                37.702460102169645
              ],
              [
                -0.726470506810771,
                37.66518783565701
              ],
              [
                -0.7468969388599215,
                37.68378322874576
              ],
              [
                -0.7512100899248367,
                37.71328357403775
              ],
              [
                -0.7503149077330074,
                37.74603905193604
              ],
              [
                -0.7545059886887704,
                37.774400041625334
              ],
              [
                -0.7494197258047405,
                37.774888356926766
              ],
              [
                -0.7481990234336406,
                37.7731795560357
              ],
              [
                -0.748199022825159,
                37.770493830803936
              ],
              [
                -0.7469783193603334,
                37.768215341757596
              ],
              [
                -0.7436417304999402,
                37.763983318598335
              ],
              [
                -0.7375382147600641,
                37.75364810766819
              ],
              [
                -0.7327367829514301,
                37.747748099471636
              ]
            ]
          ],
          [
            [
              [
                1.5263832647126128,
                38.67776772208939
              ],
              [
                1.5656838147387242,
                38.691485469951154
              ],
              [
                1.5823673846050395,
                38.67491290834467
              ],
              [
                1.5813908205711882,
                38.65306218494746
              ],
              [
                1.5574857507344442,
                38.64883895821067
              ],
              [
                1.5234481138045108,
                38.6494002430991
              ],
              [
                1.474222865030717,
                38.67459664637047
              ],
              [
                1.4580856312967123,
                38.68134078174051
              ],
              [
                1.4387313150063266,
                38.6702740108141
              ],
              [
                1.4290470712003698,
                38.66494378146911
              ],
              [
                1.4127916808468395,
                38.64644595812701
              ],
              [
                1.3969766998259772,
                38.63864628077069
              ],
              [
                1.3829503336545503,
                38.642061024610385
              ],
              [
                1.3875505396858767,
                38.66237781338717
              ],
              [
                1.3834595488112846,
                38.66999999931741
              ],
              [
                1.3834741541945026,
                38.68040586967064
              ],
              [
                1.3886824881443545,
                38.687119880819516
              ],
              [
                1.3933211597484312,
                38.6962750940827
              ],
              [
                1.3937280608853309,
                38.704209685726966
              ],
              [
                1.3864852228999704,
                38.707668497182645
              ],
              [
                1.382823112801215,
                38.71157458083001
              ],
              [
                1.388612435847621,
                38.71911489397671
              ],
              [
                1.401002263161612,
                38.730326370168086
              ],
              [
                1.4080292797707017,
                38.7244859627481
              ],
              [
                1.418142123743763,
                38.72789145293082
              ],
              [
                1.427907747888321,
                38.73936593660648
              ],
              [
                1.4313257167970868,
                38.75486885231373
              ],
              [
                1.4353947271189276,
                38.75535718133461
              ],
              [
                1.4365340502624167,
                38.75401442823152
              ],
              [
                1.4365340490478382,
                38.75161353520266
              ],
              [
                1.4375106133300095,
                38.74925369606138
              ],
              [
                1.4860945965470402,
                38.69456608399389
              ],
              [
                1.5263832647126128,
                38.67776772208939
              ]
            ]
          ],
          [
            [
              [
                1.6059676446001216,
                39.091294740969225
              ],
              [
                1.600840690711879,
                39.08238349389584
              ],
              [
                1.6069442078551348,
                39.06236410876801
              ],
              [
                1.6230574887027878,
                39.029201654457076
              ],
              [
                1.6064559241847867,
                39.02838765713152
              ],
              [
                1.593272332834265,
                39.020249850226925
              ],
              [
                1.5846460302193628,
                39.00743238762698
              ],
              [
                1.5813908204063603,
                38.99192935128756
              ],
              [
                1.576182488134918,
                38.985825931712135
              ],
              [
                1.5411889989103509,
                38.967759629401684
              ],
              [
                1.5097762381666964,
                38.93016187391045
              ],
              [
                1.4972436854575382,
                38.9218609947461
              ],
              [
                1.4694930345114101,
                38.91026432089521
              ],
              [
                1.458669466761302,
                38.900132519971024
              ],
              [
                1.4549259766479405,
                38.90403875369048
              ],
              [
                1.448415561506319,
                38.90879961864036
              ],
              [
                1.444997591276734,
                38.9131532829944
              ],
              [
                1.4285587897369483,
                38.89659247670037
              ],
              [
                1.4147284754771132,
                38.890621807138686
              ],
              [
                1.4041447274703895,
                38.856756972782414
              ],
              [
                1.4031049518767493,
                38.83227769332825
              ],
              [
                1.37065043384202,
                38.831809535124556
              ],
              [
                1.3608504561964883,
                38.851914657946296
              ],
              [
                1.3435164715749286,
                38.862372071088494
              ],
              [
                1.3288680346316384,
                38.857896168238824
              ],
              [
                1.3220320966335388,
                38.857896168238824
              ],
              [
                1.3186141286025843,
                38.8591168662035
              ],
              [
                1.3177189467345494,
                38.859849467107466
              ],
              [
                1.307790560637445,
                38.857896168238824
              ],
              [
                1.3003035815627417,
                38.87046939797407
              ],
              [
                1.2834578797112883,
                38.87461997434832
              ],
              [
                1.2666121752973534,
                38.87034744686316
              ],
              [
                1.2599389976507178,
                38.857896168238824
              ],
              [
                1.2282007176806367,
                38.87461997434832
              ],
              [
                1.2166447264406006,
                38.8850771203259
              ],
              [
                1.2121688154221764,
                38.903224902893975
              ],
              [
                1.22429446768522,
                38.92735435020199
              ],
              [
                1.2275496757913842,
                38.94200280475017
              ],
              [
                1.2184350916119078,
                38.95408756594099
              ],
              [
                1.2267358721746382,
                38.96019100851166
              ],
              [
                1.2368270195602806,
                38.96515543487328
              ],
              [
                1.2482202478420266,
                38.96637601776237
              ],
              [
                1.2599389988815726,
                38.96092371503889
              ],
              [
                1.2672632172815426,
                38.9660505690358
              ],
              [
                1.276866081492258,
                38.968003565581775
              ],
              [
                1.300954623768457,
                38.967759629401684
              ],
              [
                1.2922469406218633,
                39.00987370446815
              ],
              [
                1.2928166012040228,
                39.033270447797506
              ],
              [
                1.304453972248157,
                39.04344314026627
              ],
              [
                1.3175561863100653,
                39.047593540574915
              ],
              [
                1.3325301446301767,
                39.05723714356992
              ],
              [
                1.356781445040174,
                39.07762264315924
              ],
              [
                1.3630477210357599,
                39.07762264315924
              ],
              [
                1.3722436851908768,
                39.07139708140848
              ],
              [
                1.3919376969510386,
                39.083319543796506
              ],
              [
                1.4033309240072618,
                39.07762264315924
              ],
              [
                1.423187695694525,
                39.09056219777105
              ],
              [
                1.4506942062263422,
                39.101792600180815
              ],
              [
                1.4786889974279982,
                39.10773338636683
              ],
              [
                1.4995223328969118,
                39.10488528112619
              ],
              [
                1.5086369155431878,
                39.11436602708094
              ],
              [
                1.5227156909011104,
                39.11888254062748
              ],
              [
                1.5371199873352748,
                39.11802797301675
              ],
              [
                1.5535587905542931,
                39.107652158433616
              ],
              [
                1.5603947272194154,
                39.105821059937625
              ],
              [
                1.5783797549440732,
                39.10488528112619
              ],
              [
                1.589691600968516,
                39.10276913939639
              ],
              [
                1.5979110050907352,
                39.09813074156255
              ],
              [
                1.6059676446001216,
                39.091294740969225
              ]
            ]
          ],
          [
            [
              [
                3.354502800448346,
                39.78436923461192
              ],
              [
                3.383148633217232,
                39.77794012490391
              ],
              [
                3.439789257913472,
                39.75197982199022
              ],
              [
                3.474375849389048,
                39.749701376168446
              ],
              [
                3.4685164701018856,
                39.73932515276953
              ],
              [
                3.469411654858147,
                39.73106516283344
              ],
              [
                3.472666861924611,
                39.7235781301387
              ],
              [
                3.47437584534088,
                39.7155214565713
              ],
              [
                3.4705509767922016,
                39.71031320602814
              ],
              [
                3.4643660833615315,
                39.70640704656468
              ],
              [
                3.4614363961858654,
                39.70005943828021
              ],
              [
                3.4675399111010665,
                39.687567513534944
              ],
              [
                3.4538680327856994,
                39.65969460053155
              ],
              [
                3.4432072294340967,
                39.64577885474534
              ],
              [
                3.4299422551529304,
                39.639838025415415
              ],
              [
                3.4130965525095083,
                39.635077363502724
              ],
              [
                3.4018660830434784,
                39.62323645656867
              ],
              [
                3.398692254398119,
                39.607733489527355
              ],
              [
                3.406016472651929,
                39.59198643347596
              ],
              [
                3.36540774573417,
                39.56305559544636
              ],
              [
                3.3232528010123987,
                39.52387122244634
              ],
              [
                3.2917586595646138,
                39.47577543125152
              ],
              [
                3.2824813182658614,
                39.42011153494726
              ],
              [
                3.2727156909047785,
                39.42475006109707
              ],
              [
                3.26880943871853,
                39.42755754254008
              ],
              [
                3.2526147797407914,
                39.38617583181332
              ],
              [
                3.2210392602334075,
                39.35989011885976
              ],
              [
                3.1294051444511157,
                39.31574130736979
              ],
              [
                3.0909936859055893,
                39.290065815765026
              ],
              [
                3.083262563909212,
                39.280096608570766
              ],
              [
                3.0791121761709177,
                39.276882306632906
              ],
              [
                3.0699975911906368,
                39.27175522215835
              ],
              [
                3.0608016304180072,
                39.26906982361529
              ],
              [
                3.0566512391174934,
                39.2729760536495
              ],
              [
                3.029307489484401,
                39.30463297990237
              ],
              [
                3.022959833634304,
                39.3081730292038
              ],
              [
                3.0073348316171256,
                39.313747437048185
              ],
              [
                3.0013126960441254,
                39.31769440599102
              ],
              [
                2.9967554065795583,
                39.326971854347846
              ],
              [
                2.994639521143524,
                39.33795822069849
              ],
              [
                2.991384311303011,
                39.347276129606875
              ],
              [
                2.984222853037283,
                39.35114173970427
              ],
              [
                2.9744572277495918,
                39.35346105625501
              ],
              [
                2.958832226013834,
                39.36322656223327
              ],
              [
                2.950043163037706,
                39.3655051407751
              ],
              [
                2.938161655701783,
                39.364366001554664
              ],
              [
                2.922373894268101,
                39.35972729964863
              ],
              [
                2.9126082703016696,
                39.35866942887412
              ],
              [
                2.825450067973369,
                39.36359298298698
              ],
              [
                2.786631705277334,
                39.37592181638887
              ],
              [
                2.7617293644444976,
                39.400214040140604
              ],
              [
                2.7512313141951785,
                39.45477923121699
              ],
              [
                2.7365828789367233,
                39.46210357831568
              ],
              [
                2.739512565724371,
                39.47829822365289
              ],
              [
                2.754893423759247,
                39.50263083604842
              ],
              [
                2.743500196866532,
                39.52338294370902
              ],
              [
                2.7150985035562516,
                39.543524448057376
              ],
              [
                2.681651237113937,
                39.55866113345592
              ],
              [
                2.6552840481447366,
                39.564723885333024
              ],
              [
                2.633474154523474,
                39.559271515559075
              ],
              [
                2.569102409610851,
                39.53152087044999
              ],
              [
                2.5556746748804913,
                39.52004628155836
              ],
              [
                2.5449324885540476,
                39.49298741597509
              ],
              [
                2.5201929038907216,
                39.47284568098669
              ],
              [
                2.4926863944132664,
                39.47024163752411
              ],
              [
                2.4738061858135367,
                39.49579489111294
              ],
              [
                2.4716902988286216,
                39.49791077827294
              ],
              [
                2.4690047539509243,
                39.50588613098042
              ],
              [
                2.4721785810453154,
                39.512152333050494
              ],
              [
                2.4806421222925787,
                39.51622136344872
              ],
              [
                2.4539494167000777,
                39.537421105650935
              ],
              [
                2.4458113946904274,
                39.52887610092186
              ],
              [
                2.4381616556877033,
                39.52521399088909
              ],
              [
                2.431162955227713,
                39.52769588397034
              ],
              [
                2.425954624680668,
                39.537421105650935
              ],
              [
                2.3982853526773598,
                39.524969850963295
              ],
              [
                2.3918563167320053,
                39.523749152727206
              ],
              [
                2.38209069168607,
                39.52924231307481
              ],
              [
                2.373708530845032,
                39.54718666272547
              ],
              [
                2.355642122221633,
                39.55866113345592
              ],
              [
                2.3507593093229553,
                39.57648332245957
              ],
              [
                2.3517358722626174,
                39.59674707397277
              ],
              [
                2.3576766285179187,
                39.61188381492483
              ],
              [
                2.429372593313116,
                39.64667400337284
              ],
              [
                2.4504500647878644,
                39.650335905828655
              ],
              [
                2.468272330824306,
                39.65936911254735
              ],
              [
                2.517588738603994,
                39.70014073997006
              ],
              [
                2.532399935571791,
                39.706366244191926
              ],
              [
                2.5524194672889196,
                39.70868563662306
              ],
              [
                2.5696720721553836,
                39.71308023485235
              ],
              [
                2.586599155176876,
                39.72382234665556
              ],
              [
                2.6176863957999936,
                39.749701376168446
              ],
              [
                2.6219181652686956,
                39.75446200143399
              ],
              [
                2.629079622732568,
                39.766872442721066
              ],
              [
                2.631358267895173,
                39.770127587317894
              ],
              [
                2.6359969417906446,
                39.77102291376594
              ],
              [
                2.6474715510021167,
                39.769232564431185
              ],
              [
                2.6518660808865566,
                39.770127587317894
              ],
              [
                2.676036004778055,
                39.78908931788294
              ],
              [
                2.67920983349561,
                39.79401287311152
              ],
              [
                2.683604364879192,
                39.79621016736605
              ],
              [
                2.7039494137717837,
                39.81415427366861
              ],
              [
                2.7106225936120136,
                39.818549013230765
              ],
              [
                2.717946810306845,
                39.82013575829763
              ],
              [
                2.747406445508072,
                39.831610383420205
              ],
              [
                2.7617293646341587,
                39.84052166950663
              ],
              [
                2.773203973421156,
                39.8496362367205
              ],
              [
                2.78484133994164,
                39.856716066325575
              ],
              [
                2.7996525392513285,
                39.85956446693743
              ],
              [
                2.803233269295385,
                39.86159904689865
              ],
              [
                2.809580926822194,
                39.870550976604726
              ],
              [
                2.813243034102083,
                39.87258529070767
              ],
              [
                2.834157745977676,
                39.87116105850214
              ],
              [
                2.843597851092382,
                39.87258529070767
              ],
              [
                2.8730574895047885,
                39.88349040578947
              ],
              [
                2.933278843574934,
                39.91449626723661
              ],
              [
                2.9641219398245853,
                39.92096580855489
              ],
              [
                3.020274284384342,
                39.925156927681826
              ],
              [
                3.0756942067644477,
                39.936102590857104
              ],
              [
                3.1794539739512246,
                39.96877688109942
              ],
              [
                3.1931258461087837,
                39.95510482987954
              ],
              [
                3.198415559644412,
                39.95929588232043
              ],
              [
                3.201345245695473,
                39.960516526883545
              ],
              [
                3.2142033201028806,
                39.95510482987954
              ],
              [
                3.203623892749346,
                39.94916405288179
              ],
              [
                3.1684676435173955,
                39.93638740688886
              ],
              [
                3.1556095732165805,
                39.93402754984933
              ],
              [
                3.1408797543301907,
                39.92808667678221
              ],
              [
                3.12745201838488,
                39.91669338808098
              ],
              [
                3.1154891274333725,
                39.90875875646771
              ],
              [
                3.1043400416699134,
                39.91351970444044
              ],
              [
                3.096934442665949,
                39.91351970444044
              ],
              [
                3.0947371768839957,
                39.88121177665111
              ],
              [
                3.1302189466940535,
                39.87641026695154
              ],
              [
                3.2067977196743405,
                39.89301164234106
              ],
              [
                3.206797721968119,
                39.88682688802469
              ],
              [
                3.1967879589461115,
                39.88121177665111
              ],
              [
                3.1955672557778265,
                39.87453858929636
              ],
              [
                3.1964624372434245,
                39.8671329571494
              ],
              [
                3.193125846146119,
                39.85956446693743
              ],
              [
                3.187185092446901,
                39.85435621482475
              ],
              [
                3.1814884753320722,
                39.851385704935275
              ],
              [
                3.165212437645277,
                39.84589274820009
              ],
              [
                3.133555533949416,
                39.83954492240823
              ],
              [
                3.1263126973135997,
                39.83185464247681
              ],
              [
                3.1248478525580574,
                39.81110264151384
              ],
              [
                3.1364852223698674,
                39.78876376247375
              ],
              [
                3.1626082694485014,
                39.76911044725792
              ],
              [
                3.194834832144974,
                39.75499096204494
              ],
              [
                3.2238875682168118,
                39.749701376168446
              ],
              [
                3.2924910842639785,
                39.749701376168446
              ],
              [
                3.309906444969234,
                39.755072270887304
              ],
              [
                3.3403426435399974,
                39.77899808656244
              ],
              [
                3.354502800448346,
                39.78436923461192
              ]
            ]
          ],
          [
            [
              [
                4.302907745627565,
                39.925523069960846
              ],
              [
                4.3073022797515295,
                39.91054920958151
              ],
              [
                4.328786654579325,
                39.88344959173931
              ],
              [
                4.337087433765047,
                39.86717346779374
              ],
              [
                4.330332876768562,
                39.86717346779374
              ],
              [
                4.326263870324944,
                39.87343995254909
              ],
              [
                4.319753453273646,
                39.879217945326005
              ],
              [
                4.311778193083943,
                39.884182128773055
              ],
              [
                4.302907746677486,
                39.88759994110058
              ],
              [
                4.300059438910307,
                39.82176331739477
              ],
              [
                4.248138869410834,
                39.81647376603063
              ],
              [
                4.177175326308307,
                39.84332918365339
              ],
              [
                4.015065951944152,
                39.92576736650079
              ],
              [
                3.9813745421253484,
                39.93606177328387
              ],
              [
                3.941335481164139,
                39.93675355593268
              ],
              [
                3.8693139958666336,
                39.925523069960846
              ],
              [
                3.8306583962341914,
                39.93606177328387
              ],
              [
                3.8348901725734086,
                39.94798424955728
              ],
              [
                3.835703969704233,
                39.96242898584732
              ],
              [
                3.839121941859199,
                39.975572051144724
              ],
              [
                3.8505151707441,
                39.98387282710343
              ],
              [
                3.8423771489484775,
                39.98940664035302
              ],
              [
                3.8220320981706046,
                39.99514400735602
              ],
              [
                3.812917514000486,
                40.00120677302265
              ],
              [
                3.803396029989219,
                40.0131696634397
              ],
              [
                3.8031518890006204,
                40.01813385602967
              ],
              [
                3.80705813898632,
                40.0232608082904
              ],
              [
                3.809499544989611,
                40.03538645946102
              ],
              [
                3.821869336969768,
                40.047634180441825
              ],
              [
                3.891530794965015,
                40.05955638023139
              ],
              [
                3.9154565760436575,
                40.05198802518856
              ],
              [
                4.011892122963933,
                40.05955638023139
              ],
              [
                4.052012566040457,
                40.05817292095738
              ],
              [
                4.063405794963469,
                40.05955638023139
              ],
              [
                4.077565950954553,
                40.064276431808466
              ],
              [
                4.094330274041667,
                40.07473379299439
              ],
              [
                4.105072461968577,
                40.07941315149464
              ],
              [
                4.107839389049033,
                40.06761302534175
              ],
              [
                4.116791212004967,
                40.059637762233876
              ],
              [
                4.1390893889568785,
                40.04592519494983
              ],
              [
                4.13697350399282,
                40.04303619965496
              ],
              [
                4.13485761801059,
                40.035711981500505
              ],
              [
                4.135427280014928,
                40.02822500270821
              ],
              [
                4.142263217015369,
                40.024807033727875
              ],
              [
                4.1485294929778105,
                40.02781809994441
              ],
              [
                4.1559350920138245,
                40.03465403965198
              ],
              [
                4.165782096956642,
                40.04592519494983
              ],
              [
                4.16382897199573,
                40.06057363479439
              ],
              [
                4.170502148957628,
                40.06460195300128
              ],
              [
                4.176524285016716,
                40.05923086178236
              ],
              [
                4.172618034956566,
                40.04592519494983
              ],
              [
                4.178640170004118,
                40.03884511919145
              ],
              [
                4.206716342015608,
                40.024807033727875
              ],
              [
                4.212494337000143,
                40.01723867400364
              ],
              [
                4.21688886799719,
                40.012600001865636
              ],
              [
                4.227224155000314,
                40.00490957201263
              ],
              [
                4.232676629001082,
                40.00271230704668
              ],
              [
                4.247487825999852,
                40.000392970990696
              ],
              [
                4.254567904957804,
                39.9974632810436
              ],
              [
                4.264903190621268,
                39.98639555748754
              ],
              [
                4.273366731959009,
                39.96995672492969
              ],
              [
                4.272390172430262,
                39.9553491383235
              ],
              [
                4.254567906727676,
                39.94969318120751
              ],
              [
                4.270111526403896,
                39.94375245722726
              ],
              [
                4.285899286702736,
                39.94460691648981
              ],
              [
                4.298024934376734,
                39.941961906368974
              ],
              [
                4.302907745627565,
                39.925523069960846
              ]
            ]
          ],
          [
            [
              [
                2.985366534343094,
                39.166176232342565
              ],
              [
                2.982307966145976,
                39.13918351805575
              ],
              [
                2.962154469058888,
                39.11606216962181
              ],
              [
                2.9308667606830507,
                39.118175936943125
              ],
              [
                2.913614193117488,
                39.15196268327858
              ],
              [
                2.9404242305718373,
                39.1719303481152
              ],
              [
                2.9805824298267583,
                39.18556055668098
              ],
              [
                2.985366534343094,
                39.166176232342565
              ]
            ]
          ],
          [
            [
              [
                -4.30004512813857,
                35.172723835888796
              ],
              [
                -4.298700710091077,
                35.17261202518705
              ],
              [
                -4.296899558913121,
                35.172249021057105
              ],
              [
                -4.297730464110053,
                35.171536827269136
              ],
              [
                -4.29939227390882,
                35.1716555168141
              ],
              [
                -4.30093538305755,
                35.172070977278764
              ],
              [
                -4.301884988064596,
                35.17266448167767
              ],
              [
                -4.3010540830129615,
                35.17290187974062
              ],
              [
                -4.30004512813857,
                35.172723835888796
              ]
            ]
          ],
          [
            [
              [
                -3.9029624589815533,
                35.215309630850605
              ],
              [
                -3.902329379961717,
                35.21590471160962
              ],
              [
                -3.9019568499429527,
                35.215464448434375
              ],
              [
                -3.902532578924323,
                35.214787119269396
              ],
              [
                -3.9031317899106974,
                35.21503869541713
              ],
              [
                -3.9029624589815533,
                35.215309630850605
              ]
            ]
          ],
          [
            [
              [
                -3.9007323980445068,
                35.21782706778983
              ],
              [
                -3.899953472097772,
                35.217860937126446
              ],
              [
                -3.8998180068896393,
                35.21728519609479
              ],
              [
                -3.9004953339958433,
                35.21735293474523
              ],
              [
                -3.901003329099652,
                35.21721747624272
              ],
              [
                -3.90130812694274,
                35.21731906541965
              ],
              [
                -3.9012742600731025,
                35.217623870580944
              ],
              [
                -3.9007323980445068,
                35.21782706778983
              ]
            ]
          ],
          [
            [
              [
                -2.43424251403475,
                35.185230370496036
              ],
              [
                -2.429393926977235,
                35.18603846271682
              ],
              [
                -2.4265019919116,
                35.18211367009669
              ],
              [
                -2.431414171072115,
                35.17876559126282
              ],
              [
                -2.4358587100001294,
                35.18118987801964
              ],
              [
                -2.43424251403475,
                35.185230370496036
              ]
            ]
          ],
          [
            [
              [
                -5.4187737955364845,
                35.91559729168725
              ],
              [
                -5.415969541061549,
                35.9135310217027
              ],
              [
                -5.417888242127176,
                35.91087436157855
              ],
              [
                -5.420249720381064,
                35.91161233470225
              ],
              [
                -5.420840090350806,
                35.914268996372975
              ],
              [
                -5.4187737955364845,
                35.91559729168725
              ]
            ]
          ]
        ]
      }
    }
  ]
};

export default spainShape;